import { proxyCustomElement, HTMLElement, createEvent, h, Host, Fragment } from '@stencil/core/internal/client';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire();
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

const wdprSingleSelectCss = ":host{--font-family-base:var(--font-family-base-theme, InspireTWDC);--font-family-light:var(--font-family-light-theme, InspireTWDCLight);--font-family-heavy:var(--font-family-heavy-theme, InspireTWDCHeavy);--font-family-black:var(--font-family-black-theme, InspireTWDCBlack);--font-family-medium:var(--font-family-medium-theme, InspireTWDCMedium);--font-family-roman:var(--font-family-roman-theme, InspireTWDCRoman);--font-family-book:var(--font-family-book-theme, InspireTWDCBook);--font-weight-light:var(--font-weight-light-theme, 200);--font-weight-heavy:var(--font-weight-heavy-theme, 700);--font-weight-black:var(--font-weight-black-theme, 900);--font-weight-medium:var(--font-weight-medium-theme, 500);--font-weight-roman:var(--font-weight-roman-theme, 400);--font-weight-book:var(--font-weight-book-theme, 400);--font50-line-height:var(--font50-line-height-theme, 60px);--font40-line-height:var(--font40-line-height-theme, 50px);--font36-line-height:var(--font36-line-height-theme, 48px);--font28-line-height:var(--font28-line-height-theme, 36px);--font24-line-height:var(--font24-line-height-theme, 32px);--font20-line-height:var(--font20-line-height-theme, 28px);--font18-line-height:var(--font18-line-height-theme, 26px);--font16-line-height:var(--font16-line-height-theme, 24px);--font14-line-height:var(--font14-line-height-theme, 20px);--font12-line-height:var(--font12-line-height-theme, 20px)}:host{--font-base:{\n    font-family: var(--font-family-base)}; --font-light:{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}; --font-heavy:{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}; --font-black:{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}; --font-medium:{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}; --font-roman:{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}; --font-book:{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}; --font50:{font-size:50px;line-height:var(--font50-line-height)}; --font40:{font-size:40px;line-height:var(--font40-line-height)}; --font36:{font-size:36px;line-height:var(--font36-line-height)}; --font28:{font-size:28px;line-height:var(--font28-line-height)}; --font24:{font-size:24px;line-height:var(--font24-line-height)}; --font20:{font-size:20px;line-height:var(--font20-line-height)}; --font18:{font-size:18px;line-height:var(--font18-line-height)}; --font16:{font-size:16px;line-height:var(--font16-line-height)}; --font14:{font-size:14px;line-height:var(--font14-line-height)}; --font12:{font-size:12px;line-height:var(--font12-line-height)}; } .font-base{font-family:var(--font-family-base)}.light{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}.heavy{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}.black{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}.medium{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}.roman{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}.book{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.font50{font-size:50px;line-height:var(--font50-line-height)}.font40{font-size:40px;line-height:var(--font40-line-height)}.font36{font-size:36px;line-height:var(--font36-line-height)}.font28{font-size:28px;line-height:var(--font28-line-height)}.font24{font-size:24px;line-height:var(--font24-line-height)}.font20{font-size:20px;line-height:var(--font20-line-height)}.font18{font-size:18px;line-height:var(--font18-line-height)}.font16,.custom-dropdown-container .options-list .option-item,.custom-dropdown-container .trigger-button,.native-dropdown-container .native-select{font-size:16px;line-height:var(--font16-line-height)}.font14{font-size:14px;line-height:var(--font14-line-height)}.font12{font-size:12px;line-height:var(--font12-line-height)}.font-lg-1{font-size:50px;line-height:var(--font50-line-height)}.font-lg-2{font-size:40px;line-height:var(--font40-line-height)}.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}@media only screen and (min-width: 481px) and (max-width: 1179.98px){.font-lg-1,.font-lg-2,.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}@media only screen and (max-width: 480.98px){.font-lg-1,.font-lg-2,.font-md-1,.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}:host{font-family:var(--font-family-base)}:host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}:host{--primary:var(--primary-theme);--primary-dark:var(--primary-dark-theme);--primary-background:var(--primary-background-theme);--primary-other:var(--primary-other-theme);--primary-disabled:var(--primary-disabled-theme);--primary-message:var(--primary-message-theme);--primary-alert:var(--primary-alert-theme);--primary-gradient-from:var(--primary-gradient-from-theme);--primary-gradient-to:var(--primary-gradient-to-theme);--secondary-focus:var(--secondary-focus-theme);--secondary-hover:var(--secondary-hover-theme);--secondary-disabled:var(--secondary-disabled-theme);--secondary-background:var(--secondary-background-theme);--secondary-other-dark:var(--secondary-other-dark-theme);--secondary-other-hover:var(--secondary-other-hover-theme);--secondary-other-disabled:var(--secondary-other-disabled-theme);--secondary-other-good-to-go:var(--secondary-other-good-to-go-theme);--secondary-message:var(--secondary-message-theme);--secondary-message-detail:var(--secondary-message-detail-theme);--secondary-message-chrome:var(--secondary-message-chrome-theme);--secondary-gradient-from:var(--secondary-gradient-from-theme);--secondary-gradient-to:var(--secondary-gradient-to-theme);--secondary-inactive:var(--secondary-inactive-theme);--reversed-hover:var(--reversed-hover-theme);--link:var(--link-theme);--outline-color:var(--outline-color-theme);--outline-style:var(--outline-style-theme);--outline-width:var(--outline-width-theme)}.primary{color:var(--primary)}.primary:hover{color:var(--secondary-hover)}.primary[disabled]{color:var(--secondary-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.primary-dark{color:var(--primary-dark)}.primary-other{color:var(--primary-other)}.primary-message{color:var(--primary-message)}.primary-alert{color:var(--primary-alert)}.background-primary-background{background-color:var(--primary-background)}.background-primary{background-color:var(--primary)}.background-primary-dark{background-color:var(--primary-dark)}.background-primary-other{background-color:var(--primary-other)}.background-primary-message{background-color:var(--primary-message)}.background-primary-alert{background-color:var(--primary-alert)}.background-primary-gradient{background:linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to))}.secondary-other-dark{color:var(--secondary-other-dark)}.secondary-other-dark:hover{color:var(--secondary-other-hover)}.secondary-other-dark[disabled]{color:var(--secondary-other-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.secondary-other-good-to-go{color:var(--secondary-other-good-to-go)}.secondary-message{color:var(--secondary-message)}.secondary-message-detail{color:var(--secondary-message-detail)}.secondary-message-chrome{color:var(--secondary-message-chrome)}.background-secondary{background-color:var(--secondary-background)}.background-secondary-focus{background-color:var(--secondary-focus)}.background-secondary-hover{background-color:var(--secondary-hover)}.background-secondary-disabled{background-color:var(--secondary-disabled)}.background-secondary-other-hover{background-color:var(--secondary-other-hover)}.background-secondary-other-disabled{background-color:var(--secondary-other-disabled)}.background-secondary-other-dark{background-color:var(--secondary-other-dark)}.background-secondary-other-good-to-go{background-color:var(--secondary-other-good-to-go)}.background-secondary-message{background-color:var(--secondary-message)}.background-secondary-inactive{background-color:var(--secondary-inactive)}.background-secondary-message-detail{background-color:var(--secondary-message-detail)}.background-secondary-message-chrome{background-color:var(--secondary-message-chrome)}.background-secondary-gradient{background:linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to))}a,.link{color:var(--link);text-decoration:none}a:link,a:visited,a:hover,a:active,.link:link,.link:visited,.link:hover,.link:active{color:var(--link)}a:hover,a:focus,.link:hover,.link:focus{text-decoration:underline}.link{color:var(--link);cursor:pointer}a:focus,.link:focus,button:focus{outline-color:var(--outline-color);outline-style:var(--outline-style);outline-width:var(--outline-width)}:host{display:block;position:relative;width:100%;line-height:normal;color:var(--primary-dark);font-family:var(--wdpr-single-select-font-family, var(--font-base_-_font-family));font-weight:var(--wdpr-single-select-font-weight, var(--font-base_-_font-weight, 400));box-sizing:var(--wdpr-single-select-box-sizing, initial)}@media only screen and (min-width: 481px){:host{max-width:var(--wdpr-single-select-max-width, 240px)}}.native-dropdown-container{position:relative}.native-dropdown-container .label{font-size:var(--wdpr-single-select-label-font-size, 12px);line-height:var(--wdpr-single-select-label-line-height, 16px);height:var(--wdpr-single-select-label-line-height, 16px);color:var(--wdpr-single-select-label-color, var(--primary-message));position:var(--wdpr-single-select-label-position-native, static);top:var(--wdpr-single-select-label-top-native, auto);padding:var(--wdpr-single-select-label-padding-native)}.native-dropdown-container .select-and-icon-container{position:relative}.native-dropdown-container .native-select{color:var(--wdpr-single-select-color, var(--primary-message));position:relative;border-width:var(--wdpr-single-select-border-width, 0px 0px 1px 0px);border-style:solid;border-color:var(--wdpr-single-select-border-color, var(--secondary-message-detail));border-radius:var(--wdpr-single-select-border-radius, 0px);min-height:var(--wdpr-single-select-min-height-native, var(--wdpr-single-select-min-height, 30px));width:100%;appearance:none;background-color:var(--wdpr-single-select-native-background-color, initial);line-height:normal;-webkit-appearance:none;-moz-appearance:none;text-indent:1px;white-space:var(--wdpr-single-select-custom-option-item-white-space, nowrap);overflow:hidden;text-overflow:ellipsis;padding:var(--wdpr-single-select-native-padding, 0px 20px 0px 0px);z-index:var(--wdpr-single-select-native-z-index, auto);font-family:var(--wdpr-single-select-native-font-family, var(--font-light_-_font-family));font-weight:var(--wdpr-single-select-native-font-weight, var(--font-light_-_font-weight));}.native-dropdown-container .native-select::-ms-expand{display:none}.native-dropdown-container .native-select:active,.native-dropdown-container .native-select.opened{color:var(--wdpr-single-select-active-color, var(--primary-dark)) !important;border-color:var(--wdpr-single-select-active-border-color, unset unset var(--primary-dark) unset) !important;border-width:var(--wdpr-single-select-active-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px))}.native-dropdown-container .native-select:active+i,.native-dropdown-container .native-select.opened+i{color:var(--wdpr-single-select-active-color, var(--primary-dark))}.native-dropdown-container .native-select:focus{color:var(--wdpr-single-select-active-color, var(--primary-dark)) !important;border-color:var(--wdpr-single-select-active-border-color, unset unset var(--primary-dark) unset) !important;border-width:2px 2px 4px 2px}.native-dropdown-container .native-select:focus+i{color:var(--wdpr-single-select-active-color, var(--primary-dark))}.native-dropdown-container .native-select.item-selected{color:var(--wdpr-single-select-selected-color, var(--primary-dark));padding:var(--wdpr-single-select-native-padding-with-item-selected, --wdpr-single-select-native-padding, 0px 20px 0px 0px)}.native-dropdown-container i{position:absolute;right:var(--wdpr-single-select-icon-right, 0px);top:var(--wdpr-single-select-icon-top, 50%);transform:translateY(-50%);color:var(--wdpr-single-select-icon-color, var(--secondary-message));font-size:var(--wdpr-single-select-icon-font-size, 16px);line-height:var(--wdpr-single-select-icon-line-height, var(--font16-line-height));right:var(--wdpr-single-select-icon-right-native, var(--wdpr-single-select-icon-right, 0px));top:var(--wdpr-single-select-icon-top-native, var(--wdpr-single-select-icon-top, 50%));}.native-dropdown-container:hover .native-select{color:var(--wdpr-single-select-hover-color, var(--secondary-hover)) !important;border-color:var(--wdpr-single-select-hover-border-color, unset unset var(--secondary-hover) unset);border-width:var(--wdpr-single-select-hover-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px))}.native-dropdown-container:hover .label{color:var(--wdpr-single-select-hover-label-color, var(--secondary-hover)) !important}.native-dropdown-container:hover i{color:var(--wdpr-single-select-hover-icon-color, var(--secondary-hover)) !important}.native-dropdown-container.invalid .label{color:var(--wdpr-single-select-invalid-label-color, var(--primary-alert)) !important}.native-dropdown-container.invalid .native-select{color:var(--wdpr-single-select-invalid-color, var(--primary-alert)) !important;border-color:var(--wdpr-single-select-invalid-border-color, unset unset var(--primary-alert) unset) !important;border-width:var(--wdpr-single-select-invalid-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px))}.native-dropdown-container.invalid .native-select+i{color:var(--wdpr-single-select-invalid-icon-color, var(--primary-alert))}.native-dropdown-container.invalid:focus{color:var(--wdpr-single-select-invalid-color, var(--primary-alert)) !important;border-color:var(--wdpr-single-select-invalid-border-color, unset unset var(--primary-alert) unset) !important;border-width:2px 2px 4px 2px}.native-dropdown-container.invalid:focus+i{color:var(--wdpr-single-select-invalid-icon-color, var(--primary-alert)) !important}.native-dropdown-container.disabled .label{color:var(--wdpr-single-select-disabled-color, #e0e0e0)}.native-dropdown-container.disabled .native-select{background-color:var(--wdpr-single-select-disabled-background-color, unset);color:var(--wdpr-single-select-disabled-color, #e0e0e0) !important;border-color:var(--wdpr-single-select-disabled-border-color, unset unset var(--wdpr-single-select-disabled-color, #e0e0e0) unset) !important;border-width:var(--wdpr-single-select-disabled-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px))}.native-dropdown-container.disabled .native-select+i{color:var(--wdpr-single-select-disabled-color, #e0e0e0)}.custom-dropdown-container .trigger-button{position:relative;width:100%;min-height:var(--wdpr-single-select-min-height, 30px);color:var(--wdpr-single-select-color, var(--primary-message));background-color:transparent;line-height:normal;text-align:left;padding:var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px);border-width:var(--wdpr-single-select-border-width, 0px 0px 1px 0px);border-style:solid;border-color:var(--wdpr-single-select-border-color, var(--secondary-message-detail));border-radius:var(--wdpr-single-select-border-radius, 0px);cursor:pointer;appearance:none;font-family:var(--wdpr-single-select-trigger-button-font-family, var(--font-light_-_font-family));font-weight:var(--wdpr-single-select-trigger-button-font-weight, var(--font-light_-_font-weight))}.custom-dropdown-container .trigger-button .label{font-size:var(--wdpr-single-select-label-font-size, 12px);line-height:var(--wdpr-single-select-label-line-height, 16px);height:var(--wdpr-single-select-label-line-height, 16px);color:var(--wdpr-single-select-label-color, var(--primary-message))}.custom-dropdown-container .trigger-button i{position:absolute;right:var(--wdpr-single-select-icon-right, 0px);top:var(--wdpr-single-select-icon-top, 50%);transform:translateY(-50%);color:var(--wdpr-single-select-icon-color, var(--secondary-message));font-size:var(--wdpr-single-select-icon-font-size, 16px);line-height:var(--wdpr-single-select-icon-line-height, var(--font16-line-height))}.custom-dropdown-container .trigger-button .button-text-container{position:relative;height:var(--wdpr-single-select-trigger-button-text-box-height, var(--wdpr-single-select-custom-option-item-height, 24px));white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-right:var(--wdpr-single-select-custom-icon-padding-right, 20px);top:var(--wdpr-single-select-no-item-selected-text-container-top, 0px)}.custom-dropdown-container .trigger-button .button-text-container.has-image{height:50px;padding:var(--wdpr-single-select-custom-guestlist-padding, 0 10px 5px)}.custom-dropdown-container .trigger-button .button-text-container.has-image .selected-icon{font-size:var(--wdpr-single-select-label-selected-icon-font-size, 50px);width:50px;position:relative;top:10px;float:left}.custom-dropdown-container .trigger-button .button-text-container.has-image .guestlist-buttontext{top:13px;position:relative;float:left;left:20px}.custom-dropdown-container .trigger-button .button-text-container.has-image .guest-avatar{float:left;height:100%;width:auto}.custom-dropdown-container .trigger-button:hover{color:var(--wdpr-single-select-hover-color, var(--secondary-hover)) !important;border-color:var(--wdpr-single-select-hover-border-color, unset unset var(--secondary-hover) unset);border-width:var(--wdpr-single-select-hover-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));padding:var(--wdpr-single-select-hover-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px))}.custom-dropdown-container .trigger-button:hover .label{color:var(--wdpr-single-select-hover-label-color, var(--secondary-hover)) !important}.custom-dropdown-container .trigger-button:hover i{color:var(--wdpr-single-select-hover-icon-color, var(--secondary-hover)) !important}.custom-dropdown-container .trigger-button:active,.custom-dropdown-container .trigger-button.opened{color:var(--wdpr-single-select-active-color, var(--primary-dark)) !important;border-color:var(--wdpr-single-select-active-border-color, unset unset var(--primary-dark) unset) !important;border-width:var(--wdpr-single-select-active-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));padding:var(--wdpr-single-select-active-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px))}.custom-dropdown-container .trigger-button:active .label,.custom-dropdown-container .trigger-button.opened .label{color:var(--wdpr-single-select-active-label-color, var(--primary-dark)) !important}.custom-dropdown-container .trigger-button:active i,.custom-dropdown-container .trigger-button.opened i{color:var(--wdpr-single-select-active-color, var(--primary-dark)) !important}.custom-dropdown-container .trigger-button:focus{color:var(--wdpr-single-select-active-color, var(--primary-dark)) !important;border-color:var(--wdpr-single-select-active-border-color, unset unset var(--primary-dark) unset) !important;border-width:2px 2px 4px 2px}.custom-dropdown-container .trigger-button:focus+i{color:var(--wdpr-single-select-active-color, var(--primary-dark))}.custom-dropdown-container .trigger-button.item-selected{color:var(--wdpr-single-select-selected-color, var(--primary-dark))}.custom-dropdown-container .trigger-button.item-selected .button-text-container{top:var(--wdpr-single-select-item-selected-text-container-top, 0px)}.custom-dropdown-container .trigger-button.item-selected i{color:var(--wdpr-single-select-icon-selected-color, var(--secondary-message));top:var(--wdpr-single-select-icon-selected-top, var(--wdpr-single-select-icon-top, 50%))}.custom-dropdown-container .trigger-button.invalid{color:var(--wdpr-single-select-invalid-color, var(--primary-alert)) !important;border-color:var(--wdpr-single-select-invalid-border-color, unset unset var(--primary-alert) unset) !important;border-width:var(--wdpr-single-select-invalid-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));padding:var(--wdpr-single-select-invalid-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px))}.custom-dropdown-container .trigger-button.invalid .label{color:var(--wdpr-single-select-invalid-label-color, var(--primary-alert)) !important}.custom-dropdown-container .trigger-button.invalid i{color:var(--wdpr-single-select-invalid-icon-color, var(--primary-alert)) !important}.custom-dropdown-container .trigger-button.invalid:focus{color:var(--wdpr-single-select-invalid-color, var(--primary-alert)) !important;border-color:var(--wdpr-single-select-invalid-border-color, unset unset var(--primary-alert) unset) !important;border-width:2px 2px 4px 2px}.custom-dropdown-container .trigger-button.invalid:focus+i{color:var(--wdpr-single-select-invalid-icon-color, var(--primary-alert)) !important}.custom-dropdown-container .trigger-button.disabled{background-color:var(--wdpr-single-select-disabled-background-color, unset);color:var(--wdpr-single-select-disabled-color, #e0e0e0) !important;border-color:var(--wdpr-single-select-disabled-border-color, unset unset var(--wdpr-single-select-disabled-color, #e0e0e0) unset) !important;border-width:var(--wdpr-single-select-disabled-border-width, var(--wdpr-single-select-border-width, 0px 0px 1px 0px));padding:var(--wdpr-single-select-disabled-custom-padding, var(--wdpr-single-select-custom-padding, 0px 0px 3px 0px));cursor:default}.custom-dropdown-container .trigger-button.disabled .label,.custom-dropdown-container .trigger-button.disabled i{color:var(--wdpr-single-select-disabled-color, #e0e0e0) !important}.custom-dropdown-container .options-list{position:absolute;margin:var(--wdpr-single-select-custom-options-list-margin, 0px);list-style:none;width:var(--wdpr-single-select-custom-options-list-width, 100%);padding:var(--wdpr-single-select-custom-options-list-padding, 0px);box-sizing:border-box;border-style:solid;border-width:var(--wdpr-single-select-custom-options-list-border-width, 1px);border-color:var(--wdpr-single-select-custom-options-list-border-color, var(--secondary-message-detail));border-radius:var(--wdpr-single-select-custom-options-list-border-radius, 0px);background:var(--wdpr-single-select-custom-options-list-background-color, white);max-height:var(--wdpr-single-select-custom-options-list-max-height, 290px);overflow-y:auto;z-index:1}.custom-dropdown-container .options-list li:nth-last-of-type(1){color:var(--wdpr-single-select-custom-options-list-last-option-color, var(--primary-dark))}.custom-dropdown-container .options-list li:nth-last-of-type(1):hover{background:var(--secondary-hover);color:white}.custom-dropdown-container .options-list li:nth-last-of-type(1):hover img{border:var(--wdpr-single-select-custom-image-border, 1px white solid);filter:var(--wdpr-single-select-last-option-image-filter-hover)}.custom-dropdown-container .options-list li:nth-last-of-type(1).selected img{filter:var(--wdpr-single-select-last-option-image-filter-selected)}.custom-dropdown-container .options-list li:nth-last-of-type(1){color:var(--wdpr-single-select-custom-options-list-last-option-color, var(--primary-dark))}.custom-dropdown-container .options-list li:nth-last-of-type(1):hover{background:var(--secondary-hover);color:white}.custom-dropdown-container .options-list li:nth-last-of-type(1):hover img{border:var(--wdpr-single-select-custom-image-border, 1px white solid)}.custom-dropdown-container .options-list .option-item{color:var(--wdpr-single-select-option-item-color, var(--primary-dark));padding:var(--wdpr-single-select-custom-option-item-padding, 12px);height:var(--wdpr-single-select-custom-option-item-height, 24px);cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;box-sizing:content-box;font-family:var(--wdpr-single-select-option-item-font-family, var(--font-base_-_font-family));font-weight:var(--wdpr-single-select-option-item-font-weight, var(--font-base_-_font-weight, 400))}.custom-dropdown-container .options-list .option-item .option-value{pointer-events:none}.custom-dropdown-container .options-list .option-item:hover{background:var(--wdpr-single-select-option-item-hover-background-color, var(--secondary-hover));color:var(--wdpr-single-select-option-item-hover-color, white)}.custom-dropdown-container .options-list .option-item:focus-within,.custom-dropdown-container .options-list .option-item:active,.custom-dropdown-container .options-list .option-item.active{outline-color:var(--wdpr-single-select-option-item-selected-background-color, var(--primary-dark));outline-width:2px}.custom-dropdown-container .options-list .option-item.selected{background:var(--wdpr-single-select-option-item-selected-background-color, var(--primary-dark));color:var(--wdpr-single-select-option-item-selected-color, white)}.custom-dropdown-container .options-list .option-item.has-image{height:40px;padding:var(--wdpr-single-select-custom-guestlist-padding, 10px)}.custom-dropdown-container .options-list .option-item.has-image img{float:left;height:100%;width:auto;border:1px white solid}.custom-dropdown-container .options-list .option-item.has-image a:hover{text-decoration:none}.custom-dropdown-container .options-list .option-item.has-image .option-value-inner{position:relative;top:8px;float:left;left:20px}.custom-dropdown-container .options-list .option-item.has-image .selected-icon{margin:0;font-size:var(--wdpr-single-select-label-selected-icon-font-size, 40px);position:relative;top:11px;width:44px;float:left;color:var(--primary-dark)}.custom-dropdown-container .options-list .option-item.has-image.selected .selected-icon{color:var(--primary)}.custom-dropdown-container .options-list .option-item.add-guest{padding:0;height:100%}.custom-dropdown-container .options-list .option-item.add-guest:hover a,.custom-dropdown-container .options-list .option-item.add-guest:active a,.custom-dropdown-container .options-list .option-item.add-guest:focus a,.custom-dropdown-container .options-list .option-item.add-guest.active a{color:white;text-decoration:none}.custom-dropdown-container .options-list .option-item.add-guest a{display:block;width:100%;padding:var(--wdpr-single-select-add-guest-custom-padding, 12px 7px)}.custom-dropdown-container .options-list .option-item .add-guest-icon{float:left;margin-right:20px;color:var(--primary)}.custom-dropdown-container .options-list::-webkit-scrollbar{width:var(--wdpr-single-select-custom-options-list-scrollbar-width, 5px);background:transparent}.custom-dropdown-container .options-list::-webkit-scrollbar-thumb{width:var(--wdpr-single-select-custom-options-list-scrollbar-width, 5px);background-color:var(--wdpr-single-select-scrollbar-color, var(--secondary-message));border-radius:var(--wdpr-single-select-custom-options-list-scrollbar-border-radius, 10px)}.custom-dropdown-container .options-list::-webkit-scrollbar-thumb:hover{background:var(--wdpr-single-select-scrollbar-color, var(--secondary-message))}.custom-dropdown-container .options-list::-webkit-scrollbar-track,.custom-dropdown-container .options-list::-webkit-scrollbar-track-piece{background:transparent}.age-label{display:block;font-size:var(--wdpr-single-select-label-age-label-font-size, 10px);line-height:var(--wdpr-single-select-label-age-label-line-height, 7px)}.avatar-rounded{border-radius:50%}.option-disabled{opacity:0.5}#invalid-icon{color:var(--wdpr-single-select-invalid-label-color, var(--primary-alert)) !important;top:5px;position:relative}#single-select-aria-description{color:var(--wdpr-single-select-invalid-label-color, var(--primary-alert)) !important;top:3px;left:2px;position:relative}.invisible{visibility:hidden}";

const WdprSingleSelect$1 = /*@__PURE__*/ proxyCustomElement(class WdprSingleSelect extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.itemSelected = createEvent(this, "item-selected", 7);
        this.valueChanged = createEvent(this, "value-changed", 7);
        /**
         * True when component has loaded and shadow dom can be accessed
         * in component logic.
         */
        this.HTMLRendered = false;
        /**
         * Whether or not the options have been normalized.
         */
        this.initialized = false;
        this.toggleCustomOptionsListVisibility = (event) => {
            this.customDropdownButton.focus();
            event.stopPropagation();
            this.opened = !this.opened;
            if (this.opened) {
                this._showDropdown();
            }
            else {
                this._hideDropdown();
            }
            // Set the focused option index to the selected option to start the arrow keys navigation from there when the dropdown is opened]
            if (this.opened) {
                const selectedOptionIndex = this.getOptionIndex(this.value);
                this.focusedOptionIndex = selectedOptionIndex > -1 ? selectedOptionIndex : -1;
                if (this.focusedOptionIndex > -1) {
                    this.customDropdownOptionsList.querySelectorAll('li')[this.focusedOptionIndex].focus();
                }
                if (selectedOptionIndex <= -1) {
                    this.customDropdownOptionsList.querySelectorAll('li')[0].focus();
                }
            }
        };
        this.selectNativeOption = () => {
            const selectedOptionKey = this.nativeDropdown.value;
            const selectedOptionIndex = this.getOptionIndex(selectedOptionKey);
            this.focusedOptionIndex = selectedOptionIndex;
            this.handleChange(selectedOptionKey);
            this.opened = false;
            this._hideDropdown();
        };
        this.selectCustomOption = (event) => {
            event.preventDefault();
            const targetedIndex = event.target.dataKey || event.target.getAttribute("data-key");
            const selectedOptionIndex = !this.isNull(targetedIndex) ? this.getOptionIndex(targetedIndex) : null;
            if (selectedOptionIndex !== null && this.disabledValues.indexOf(String(selectedOptionIndex)) < 0) {
                this.focusedOptionIndex = selectedOptionIndex;
                const selectedOptionKey = this.options[selectedOptionIndex].key;
                this.handleChange(selectedOptionKey);
                this.opened = false;
                this._hideDropdown();
                setTimeout(() => {
                    this.customDropdownButton.focus();
                });
            }
        };
        /**
         * Creates behavior for keydown events on custom dropdown containers
         * @param event key event
         */
        this.handleCustomDropdownKeyDown = (event) => {
            let itemIndexToFocus;
            switch (event.key.toLowerCase()) {
                case 'arrowup':
                    event.preventDefault();
                    if (!this.opened) {
                        this.opened = true;
                        itemIndexToFocus = this.getOptionIndex(this.value);
                    }
                    else {
                        if (this.focusedOptionIndex > 0) {
                            itemIndexToFocus = this.focusedOptionIndex - 1;
                            this.focusedOptionIndex--;
                            this.customDropdownOptionsList.querySelectorAll('li')[itemIndexToFocus].focus();
                        }
                    }
                    break;
                case 'alt':
                    event.preventDefault();
                    if (!this.opened) {
                        this.opened = true;
                        itemIndexToFocus = this.getOptionIndex(this.value);
                    }
                    else {
                        if (this.disabledValues.indexOf(String(this.focusedOptionIndex)) < 0) {
                            this.handleChangeIfNotOpened(this.focusedOptionIndex);
                            this.autoCloseCustomDropdown(event);
                            this.customDropdownButton.focus();
                        }
                    }
                    break;
                case 'arrowdown':
                    event.preventDefault();
                    if (!this.opened) {
                        this.opened = true;
                        itemIndexToFocus = this.getOptionIndex(this.value);
                    }
                    else {
                        if (this.focusedOptionIndex >= 0) {
                            itemIndexToFocus = this.focusedOptionIndex + 1;
                        }
                        else {
                            itemIndexToFocus = 0;
                        }
                        if (this.disabledValues.indexOf(String(this.focusedOptionIndex)) >= 0) {
                            this.focusedOptionIndex++;
                            this.customDropdownOptionsList.querySelectorAll('li')[itemIndexToFocus].focus();
                        }
                        else if (itemIndexToFocus < this.options.length) {
                            this.focusedOptionIndex++;
                            this.customDropdownOptionsList.querySelectorAll('li')[itemIndexToFocus].focus();
                        }
                    }
                    break;
                case 'escape':
                case 'esc': // IE Compatibility
                    event.preventDefault();
                    this.autoCloseCustomDropdown(event);
                    this.customDropdownButton.focus();
                    break;
                case ' ':
                case 'enter':
                    event.preventDefault();
                    if (!this.opened) {
                        this.opened = true;
                    }
                    else {
                        if (this.disabledValues.indexOf(String(this.focusedOptionIndex)) < 0) {
                            this.handleChangeIfNotOpened(this.focusedOptionIndex);
                            this.autoCloseCustomDropdown(event);
                            this.customDropdownButton.focus();
                        }
                    }
                    break;
                case 'home':
                    event.preventDefault();
                    this.opened = true;
                    itemIndexToFocus = 0;
                    this.focusedOptionIndex = 0;
                    this.customDropdownOptionsList.scrollTop = 0;
                    this.customDropdownOptionsList.querySelectorAll('li')[this.focusedOptionIndex].focus();
                    break;
                case 'end':
                    event.preventDefault();
                    this.opened = true;
                    this.focusedOptionIndex = this.options.length - 1;
                    this.customDropdownOptionsList.scrollTop = this.customDropdownOptionsList.offsetHeight;
                    this.customDropdownOptionsList.querySelectorAll('li')[this.options.length - 1].focus();
                    break;
                case 'tab':
                    if (this.opened) {
                        if (this.disabledValues.indexOf(String(this.focusedOptionIndex)) < 0) {
                            this.handleChangeIfNotOpened(this.focusedOptionIndex);
                            this.autoCloseCustomDropdown(event);
                            this.customDropdownButton.focus();
                        }
                        else {
                            event.preventDefault();
                        }
                    }
                    break;
                case 'pageup':
                    event.preventDefault();
                    if (this.opened) {
                        if (this.focusedOptionIndex > 10) {
                            this.focusedOptionIndex = this.focusedOptionIndex - 10;
                            this.handleChangeIfNotOpened(this.focusedOptionIndex);
                        }
                        else {
                            this.focusedOptionIndex = 0;
                            this.handleChangeIfNotOpened(this.focusedOptionIndex);
                        }
                    }
                    break;
                case 'pagedown':
                    event.preventDefault();
                    if (this.opened) {
                        if (this.options.length - this.focusedOptionIndex - 1 > 10) {
                            this.focusedOptionIndex = this.focusedOptionIndex + 10;
                            this.handleChangeIfNotOpened(this.focusedOptionIndex);
                        }
                        else {
                            this.focusedOptionIndex = this.options.length - 1;
                            this.handleChangeIfNotOpened(this.focusedOptionIndex);
                        }
                    }
                    break;
                default:
                    if (48 <= event.keyCode && event.keyCode <= 90) {
                        if (!this.opened) {
                            this.opened = true;
                        }
                        const search = this._getSearchString(event.key);
                        this._filter(search, this.focusedOptionIndex);
                    }
                    break;
            }
        };
        this._getSearchString = function (char) {
            // reset typing timeout and start new timeout
            // this allows us to make multiple-letter matches, like a native select
            if (typeof this.searchTimeout === 'number') {
                window.clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = window.setTimeout(() => {
                this.searchString = '';
            }, 500);
            // add most recent letter to saved search string
            this.searchString += char;
            return this.searchString;
        };
        this.updateFocusedIndex = (event) => {
            const targetedIndex = event.target.dataKey || event.target.getAttribute("data-key");
            const newFocusedOptionIndex = this.getOptionIndex(targetedIndex);
            this.focusedOptionIndex = newFocusedOptionIndex != null ? newFocusedOptionIndex : 0;
        };
        this.guestList = false;
        this.guestListAddUrl = null;
        this.disabledValues = [];
        this.guestAvatar = '';
        this.avatarRounded = false;
        this.ageLabel = '';
        this.selectedOptionLabel = null;
        this.opened = false;
        this.customButtonErrorAriaDescribedby = '';
        this.customButtonAriaInvalid = false;
        this.customAriaLabelledby = '';
        this.customAriaReadonly = '';
        this.value = null;
        this.options = [];
        this.focusedOptionIndex = -1;
        this.searchString = '';
        this.searchValue = '';
        this.buttonText = null;
        this.label = null;
        this.placeholder = null;
        this.invalid = false;
        this.disabled = false;
        this.requiredField = 'false';
        this.forceCustomOptionsMenu = false;
        this.dropdownId = undefined;
        this.guestListSelectOptionLabel = 'select';
        this.addGuestSelectOption = false;
        this.guestAddLabel = [{ iconClass: 'di-add-button', label: 'Add Guest' }];
        this.customAriaLabel = '';
        this.customErrorAriaLabel = '';
    }
    onValueChange(newValue) {
        this.updateLabelsAndValue();
        this.valueChanged.emit(newValue);
    }
    onOptionChange() {
        if (this.initialized) {
            this.configureOptions();
        }
    }
    componentWillLoad() {
        this.dropdownId = this.generateRandomId();
        this.configureOptions();
    }
    componentDidLoad() {
        this.HTMLRendered = true;
        this.setInitialNativeValue();
    }
    configureOptions() {
        if (!(this.options instanceof Array)) {
            this.options = JSON.parse(this.options);
        }
        this.normalizeOptions();
        this.setInitialFocusedOptionIndex();
        this.setupGuestListOptions();
        this.normalizeDisabledValues();
        this.updateLabelsAndValue();
    }
    normalizeOptions() {
        this.initialized = false;
        // If the array is not a key/value object collection, (e.g. array of strings/numbers), normalize it to key/value objects
        if (this.options && this.options.length && typeof this.options[0] !== 'object') {
            const newArray = [];
            for (let i = 0; i < this.options.length; i++) {
                newArray.push({
                    key: String(i + 1),
                    value: this.options[i]
                });
            }
            this.options = newArray;
        }
        this.initialized = true;
    }
    setInitialFocusedOptionIndex() {
        if (!this.isNull(this.value)) {
            this.focusedOptionIndex = this.getOptionIndex(this.value);
        }
    }
    setupGuestListOptions() {
        if (this.guestList && this.options.length !== 0 && this.addGuestSelectOption) {
            if (this.options[0].value !== this.guestListSelectOptionLabel) {
                const updatedGuestOption = [];
                updatedGuestOption.unshift({
                    key: '0',
                    value: this.guestListSelectOptionLabel,
                    img: 'default',
                    age: ''
                });
                for (let i = 0; i < this.options.length; i++) {
                    updatedGuestOption.push({
                        key: String(i + 1),
                        value: this.options[i].value,
                        img: this.options[i].img,
                        age: this.options[i].age
                    });
                }
                this.options = updatedGuestOption;
                this.guestAvatar = !this.isNull(this.value) ? this.options[this.value].img : '';
            }
        }
    }
    normalizeDisabledValues() {
        if (typeof this.disabledValues !== 'object') {
            const newDisabledValues = this.disabledValues.split(',').map(String);
            this.disabledValues = newDisabledValues;
        }
    }
    updateLabelsAndValue() {
        if (this.initialized && !this.isNull(this.value)) {
            // Custom dropdown
            const selectedOptionIndex = this.getOptionIndex(this.value);
            const selectedOptionValue = this.options[selectedOptionIndex] && this.options[selectedOptionIndex].value;
            const selectedOptionLabel = typeof selectedOptionValue !== 'undefined' ? String(selectedOptionValue) : '';
            if (this.guestList && this.options.length !== 0) {
                this.guestAvatar = !this.isNull(selectedOptionIndex) && selectedOptionIndex !== -1 ? this.options[selectedOptionIndex].img : this.options[0].img;
                this.ageLabel = !this.isNull(selectedOptionIndex) && selectedOptionIndex !== -1 ? this.options[selectedOptionIndex].age : this.options[0].age;
            }
            this.buttonText = selectedOptionLabel || this.label || this.placeholder || '';
            this.selectedOptionLabel = selectedOptionLabel;
        }
        else {
            this.buttonText = this.label || this.placeholder || '';
        }
        // Native dropdown
        if (this.HTMLRendered) {
            this.setInitialNativeValue();
        }
    }
    setInitialNativeValue() {
        (this.initialized && !this.isNull(this.value)) ? this.nativeDropdown.value = this.value : this.nativeDropdown.value = '';
    }
    _showDropdown() {
        const dropdownMenu = this.customDropdownOptionsList;
        dropdownMenu.classList.remove('hidden');
    }
    _hideDropdown() {
        const dropdownMenu = this.customDropdownOptionsList;
        dropdownMenu.classList.add('hidden');
    }
    handleChange(newSelectedOptionKey) {
        const previousSelectedKey = this.value;
        // Update the general new value
        this.value = newSelectedOptionKey;
        // Update value for custom dropdown
        const selectedOptionIndex = this.getOptionIndex(newSelectedOptionKey);
        this.selectedOptionLabel = selectedOptionIndex > -1 ? this.options[selectedOptionIndex].value : '';
        // Update value for native dropdown
        this.nativeDropdown.value = newSelectedOptionKey;
        if (previousSelectedKey !== newSelectedOptionKey) {
            this.emitNewValueEvent();
        }
    }
    handleChangeIfNotOpened(newSelectedOptionIndex) {
        if (!this.opened) {
            this.opened = !this.opened;
            this._showDropdown();
        }
        if (this.focusedOptionIndex > -1) {
            const selectedOptionKey = this.options[newSelectedOptionIndex].key;
            this.handleChange(selectedOptionKey);
            this.customDropdownOptionsList.querySelectorAll('li')[newSelectedOptionIndex].focus();
        }
    }
    autoCloseCustomDropdown(event) {
        const target = event.relatedTarget || document.activeElement;
        const parentId = target.getAttribute('data-parent-dropdown-id');
        const dropdownId = target.getAttribute('data-dropdown-id');
        if (dropdownId !== this.dropdownId && parentId !== this.dropdownId) {
            this.opened = false;
            this._hideDropdown();
        }
    }
    async reset() {
        this.selectedOptionLabel = '';
        this.value = null;
        this.focusedOptionIndex = -1;
        this.buttonText = this.label || this.placeholder || '';
        this.emitNewValueEvent();
    }
    computeItemSelectedClass(value) {
        return this.isNull(value) ? '' : 'item-selected';
    }
    computeOpenedClass(opened) {
        return opened ? 'opened' : '';
    }
    computeSelectedClass(optionKey, value) {
        return optionKey === value ? 'selected' : '';
    }
    computeLabelVisibility(value) {
        return this.isNull(value) ? 'invisible' : '';
    }
    computeInvalidClass(invalid) {
        return invalid ? 'invalid' : '';
    }
    /**
     * Returns disabled class
     * @returns {string}
     */
    computeDisabledClass(disabled) {
        return disabled ? 'disabled' : '';
    }
    /**
     * Check if initial value exists
     * @returns {boolean}
     */
    computeInitialOptionSelected() {
        return this.isNull(this.value);
    }
    /**
     * Check if option is currently selected.
     * @param optionKey
     * @param value
     * @returns {boolean}
     */
    computeSelectedOptionAttribute(optionKey, value) {
        return optionKey === value;
    }
    /**
     * Determines if native options menu should be used.
     * @returns {boolean}
     */
    computeUseNativeOptionsMenu() {
        if (this.forceCustomOptionsMenu) {
            return false;
        }
        else {
            return isTouchDevice();
        }
        function isTouchDevice() {
            const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
            const mq = function (query) {
                return window.matchMedia(query).matches;
            };
            if (('ontouchstart' in window)) {
                return true;
            }
            // include the 'heartz' as a way to have a non matching MQ to help terminate the join
            // https://git.io/vznFH
            const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
            return mq(query);
        }
    }
    hasRepeats(str) {
        return /(.).*\1/.test(str);
    }
    _filter(text, option) {
        let searchIndex = this._findOptionIndexForStartsWith(text);
        let arr = [];
        if (this.hasRepeats(text) == true && option > -1) {
            for (let i = 0; i < this.options.length; i++) {
                if (this.options[i].value.toLowerCase().startsWith(text[0].toLowerCase()) && !this.options[i].disabled) {
                    arr.push(this.options[i]);
                }
            }
        }
        if (arr.length > 1) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].key == (option + 1)) {
                    if (i != arr.length - 1) {
                        searchIndex = (arr[i + 1].key - 1);
                    }
                    else {
                        searchIndex = (arr[0].key - 1);
                    }
                }
            }
        }
        if (searchIndex > -1) {
            this.focusedOptionIndex = searchIndex;
            this.customDropdownOptionsList.querySelectorAll('li')[this.focusedOptionIndex].focus();
        }
        setTimeout(() => {
            this.searchValue = '';
        }, 1000);
    }
    _findOptionIndexForStartsWith(key) {
        for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].value.toLowerCase().startsWith(key.toLowerCase()) && !this.options[i].disabled) {
                return i;
            }
            else if (this.options[i].value.startsWith(key) && !this.options[i].disabled) {
                return i;
            }
        }
        return -1;
    }
    generateRandomId() {
        let result = '';
        const length = 6;
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (let i = length; i > 0; --i) {
            result += chars[Math.floor(Math.random() * chars.length)];
        }
        return result;
    }
    getOptionIndex(optionToSearch) {
        let index = -1;
        for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i];
            if (optionToSearch === option.key || String(optionToSearch) === String(option.key)) {
                index = i;
                break;
            }
        }
        return index;
    }
    emitNewValueEvent() {
        const detail = {
            index: this.getOptionIndex(this.value),
            key: this.value,
            value: this.selectedOptionLabel
        };
        this.itemSelected.emit(detail);
    }
    computeHasImageClass(variable) {
        return variable ? 'has-image' : '';
    }
    computeAvatarRoundedClass(variable) {
        return variable ? 'avatar-rounded' : '';
    }
    isNull(variable) {
        return variable === null || variable === '' || typeof variable === 'undefined';
    }
    isEqualTo(title, string) {
        return title === string;
    }
    computeOptionDisabledClass(key, disabledValues) {
        if (disabledValues.indexOf(String(this.getOptionIndex(key))) >= 0) {
            return ('option-disabled');
        }
        else {
            return '';
        }
    }
    computeNativeOptionDisabledAttribute(key, disabledValues) {
        return disabledValues.indexOf(String(this.getOptionIndex(key))) >= 0 ? '' : null;
    }
    /**
     * Computes the aria label based on existing properties.
     * @param customAriaLabel
     * @param label
     * @param placeholder
     * @param selectedOptionLabel
     * @returns
     */
    computeAriaLabel(customAriaLabel, label, placeholder) {
        return `${customAriaLabel || label || placeholder || ''}`.trim();
    }
    /**
     * Computes whether custom error label should be displayed in Screen Readers.
     */
    computeCustomErrorAriaLabel(invalid, customErrorAriaLabel) {
        return (invalid && customErrorAriaLabel.trim() !== '') ? customErrorAriaLabel : '';
    }
    computeCustomButtonErrorAriaDescribedby(customButtonErrorAriaDescribedby) {
        return (customButtonErrorAriaDescribedby.trim() !== '') ? customButtonErrorAriaDescribedby : 'single-select-aria-description';
    }
    computeCustomAriaLabelledby(customAriaLabelledby) {
        return (customAriaLabelledby.trim() !== '') ? customAriaLabelledby : '';
    }
    computeCustomAriaReadonly(customAriaReadonly) {
        if (customAriaReadonly == 'true') {
            return true;
        }
        return false;
    }
    computeCustomButtonAriaInvalid(customButtonAriaInvalid, value) {
        if (customButtonAriaInvalid) {
            return this.isNull(value) ? 'true' : 'false';
        }
    }
    /**
     * Helper method to render the button text.
     * @return buttonText as String if guest avatar exists
     */
    renderButtonText() {
        if (this.isNull(this.guestAvatar)) {
            return (String(this.buttonText));
        }
    }
    /**
     * Allows for the dropdown element to be focused on asynchronously.
     */
    async focusDropdown() {
        if (this.computeUseNativeOptionsMenu()) {
            this.nativeDropdown.focus();
        }
        else {
            this.customDropdownButton.focus();
        }
    }
    /**
     * Helper method to render the family avatar in HTML.
     */
    renderFamilyAvatar() {
        return (h("div", null, h("span", { class: "selected-icon di di-friends-family" }), h("div", { class: "guestlist-buttontext" }, this.buttonText)));
    }
    getAriaActivedescendant() {
        if (this.value != null && !this.opened) {
            return "option-" + this.value;
        }
        else if (this.opened && this.focusedOptionIndex >= 0) {
            return "option-" + (this.focusedOptionIndex + 1);
        }
        else {
            return null;
        }
    }
    render() {
        return h(Host, null, h("div", { class: "native-dropdown-container " + this.computeInvalidClass(this.invalid) + " " + this.computeDisabledClass(this.disabled), hidden: !this.computeUseNativeOptionsMenu() }, h("div", { id: "native-dropdown-label", class: "label " + this.computeLabelVisibility(this.value), "aria-hidden": "true" }, this.label), h("div", { class: "select-and-icon-container" }, h("select", { id: "native-dropdown", ref: el => this.nativeDropdown = el, class: "native-select " + this.computeItemSelectedClass(this.value), "on-change": this.selectNativeOption, disabled: this.disabled, "aria-required": this.requiredField, "aria-label": this.computeAriaLabel(this.customAriaLabel, this.label, this.placeholder), "aria-describedby": this.computeCustomButtonErrorAriaDescribedby(this.customButtonErrorAriaDescribedby), "aria-invalid": this.computeCustomButtonAriaInvalid(this.customButtonAriaInvalid, this.value) }, h("option", { value: "", "aria-label": "", "aria-hidden": "true", selected: this.computeInitialOptionSelected(), disabled: true, hidden: true }, this.label, this.placeholder), this.options.map((option) => h("option", { value: option.key, selected: this.computeSelectedOptionAttribute(option.key, this.value), disabled: this.computeNativeOptionDisabledAttribute(option.key, this.disabledValues) != null }, option.value))), h("i", { class: "di di-norgie-opened", "aria-hidden": "true" }))), h("div", { class: "custom-dropdown-container", "on-keydown": this.handleCustomDropdownKeyDown, hidden: this.computeUseNativeOptionsMenu(), "on-focusout": (e) => this.autoCloseCustomDropdown(e) }, h("button", { id: "custom-dropdown-button", "aria-haspopup": "listbox", ref: el => this.customDropdownButton = el, "data-dropdown-id": this.dropdownId, class: "trigger-button " + this.computeOpenedClass(this.opened) + " " + this.computeItemSelectedClass(this.value) + " " + this.computeInvalidClass(this.invalid) + " " + this.computeDisabledClass(this.disabled), "on-click": this.toggleCustomOptionsListVisibility, "on-focusout": (e) => this.autoCloseCustomDropdown(e), role: "combobox", "aria-activedescendant": this.getAriaActivedescendant(), "aria-labelledby": this.computeCustomAriaLabelledby(this.customAriaLabelledby), "aria-readonly": this.computeCustomAriaReadonly(this.customAriaReadonly), "aria-controls": "custom-dropdown-options-list", "aria-required": this.requiredField, "aria-describedby": this.computeCustomButtonErrorAriaDescribedby(this.customButtonErrorAriaDescribedby), "aria-invalid": this.computeCustomButtonAriaInvalid(this.customButtonAriaInvalid, this.value), "aria-expanded": this.opened.toString(), disabled: this.disabled, "aria-label": this.computeAriaLabel(this.customAriaLabel, this.label, this.placeholder) }, h("div", { class: "label " + this.computeLabelVisibility(this.value), "aria-hidden": "true" }, this.label), h("div", { class: "button-text-container " + this.computeHasImageClass(this.guestAvatar) }, this.guestList
            ? h(Fragment, null, this.isEqualTo(this.buttonText, this.guestListSelectOptionLabel)
                ? this.renderFamilyAvatar()
                : (!this.isEqualTo(this.guestAvatar, 'default') && this.guestAvatar)
                    && h(Fragment, null, h("img", { class: "guest-avatar " + this.computeAvatarRoundedClass(this.avatarRounded), src: this.guestAvatar }), h("div", { class: "guestlist-buttontext" }, this.buttonText, h("span", { class: "age-label" }, this.ageLabel))))
            : this.renderButtonText(), h("i", { class: "di di-norgie-opened", "aria-hidden": "true" }))), h("ul", { id: "custom-dropdown-options-list", ref: el => this.customDropdownOptionsList = el, "data-parent-dropdown-id": this.dropdownId, "on-focusout": (e) => this.autoCloseCustomDropdown(e), class: "options-list hidden", role: "listbox", "aria-label": this.computeAriaLabel(this.customAriaLabel, this.label, this.placeholder), tabindex: "-1", hidden: !this.opened }, this.options.map((option) => h("li", { class: "option-item " + this.computeSelectedClass(option.key, this.value) + " " + this.computeHasImageClass(option.img) + ' ' + this.computeOptionDisabledClass(option.key, this.disabledValues), part: option.partsOverride && option.partsOverride['option-item'] || 'option-item', id: "option-" + option.key, "data-key": option.key, role: "option", "aria-selected": this.computeSelectedOptionAttribute(option.key, option.value), "data-parent-dropdown-id": this.dropdownId, "on-mousedown": this.selectCustomOption, tabindex: "-1", "on-focus": this.updateFocusedIndex, "on-focusout": (e) => this.autoCloseCustomDropdown(e), "aria-label": option.value }, (!this.isNull(option.img) && !this.isEqualTo(option.img, 'default'))
            && h("img", { class: this.computeAvatarRoundedClass(this.avatarRounded), src: option.img }), h("div", { class: "option-value" }, this.isEqualTo(option.value, this.guestListSelectOptionLabel)
            && h("span", { class: "selected-icon di di-friends-family" }), h("div", { class: "option-value-inner", part: option.partsOverride && option.partsOverride['option-value-inner'] || 'option-value-inner' }, option.value, option.age != undefined && option.age != null
            && h("span", { class: "age-label" }, option.age))))), this.guestListAddUrl != null &&
            h("li", { class: "option-item " + " add-guest", role: "menuitem", tabindex: "0", "data-parent-dropdown-id": this.dropdownId, "on-mousedown": this.selectCustomOption, "on-focus": this.updateFocusedIndex, "on-focusout": (e) => this.autoCloseCustomDropdown(e), "on-keydown": this.handleCustomDropdownKeyDown }, this.guestAddLabel.map((guestAdd) => h("a", { href: this.guestListAddUrl }, h("span", { class: "add-guest-icon di " + guestAdd.iconClass }), h("span", { class: "option-value" }, guestAdd.label)))))), this.invalid && this.customErrorAriaLabel.trim() !== ''
            ? h(Fragment, null, h("i", { id: "invalid-icon", class: "di di-alert", role: "img" }), h("span", { id: "single-select-aria-description" }, this.computeCustomErrorAriaLabel(this.invalid, this.customErrorAriaLabel)))
            : '');
    }
    static get watchers() { return {
        "value": ["onValueChange"],
        "options": ["onOptionChange"]
    }; }
    static get style() { return wdprSingleSelectCss; }
}, [1, "wdpr-single-select", {
        "guestList": [4, "guest-list"],
        "guestListAddUrl": [1, "guest-list-add-url"],
        "disabledValues": [1032, "disabled-values"],
        "guestAvatar": [1025, "guest-avatar"],
        "avatarRounded": [4, "avatar-rounded"],
        "ageLabel": [1025, "age-label"],
        "selectedOptionLabel": [1025, "selected-option-label"],
        "opened": [1028],
        "customButtonErrorAriaDescribedby": [1, "custom-button-error-aria-describedby"],
        "customButtonAriaInvalid": [4, "custom-button-aria-invalid"],
        "customAriaLabelledby": [1, "custom-aria-labelledby"],
        "customAriaReadonly": [1, "custom-aria-readonly"],
        "value": [1537],
        "options": [1032],
        "focusedOptionIndex": [1026, "focused-option-index"],
        "searchString": [1025, "search-string"],
        "searchValue": [1025, "search-value"],
        "buttonText": [1025, "button-text"],
        "label": [513],
        "placeholder": [513],
        "invalid": [516],
        "disabled": [516],
        "requiredField": [1, "required-field"],
        "forceCustomOptionsMenu": [516, "force-custom-options-menu"],
        "dropdownId": [1025, "dropdown-id"],
        "guestListSelectOptionLabel": [1, "guest-list-select-option-label"],
        "addGuestSelectOption": [4, "add-guest-select-option"],
        "guestAddLabel": [8, "guest-add-label"],
        "customAriaLabel": [1, "custom-aria-label"],
        "customErrorAriaLabel": [1, "custom-error-aria-label"],
        "reset": [64],
        "focusDropdown": [64]
    }, undefined, {
        "value": ["onValueChange"],
        "options": ["onOptionChange"]
    }]);
function defineCustomElement$1$2() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-single-select"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-single-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprSingleSelect$1);
            }
            break;
    } });
}
defineCustomElement$1$2();

var lodash = createCommonjsModule(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
});

const DEFAULT_PARAM_NAMES = {
    checkInDate: 'checkInDate',
    checkOutDate: 'checkOutDate',
    numberOfAdults: 'numberOfAdults',
    numberOfChildren: 'numberOfChildren',
    child: 'kid',
    resort: 'resort',
    accessible: 'accessible',
    shopFor: 'shopFor',
    departAirport: 'DepartAirport',
    returnAirport: 'DestinationAirport',
    travelClass: 'ClassOfTravel',
    planType: 'planType',
    Sorting: 'Sorting',
    Duration: 'Duration'
};
const DATE_RANGE_DEFAULTS = {
    checkInDateName: DEFAULT_PARAM_NAMES.checkInDate,
    checkOutDateName: DEFAULT_PARAM_NAMES.checkOutDate,
    defaultLengthOfStay: '6',
    defaultCheckinDate: '0',
    minLengthOfStay: '1',
    maxLengthOfStay: '30',
};
const ANALYTICS_LINK_IDS = {
    wdw: {
        mobileToggle: 'wdw_home_quickquote_buildyourvacation_expand',
        purchaseTicketsBtn: 'wdw_home_quickquote_purchasetickets_click',
        viewRatesBtn: 'wdw_home_quickquote_viewrates_click',
        viewRatesEuUkBtn: 'QQ_FindPrices'
    },
    dlr: {
        mobileToggle: 'dlr_home_quickquote_buildyourvacation_expand',
        purchaseTicketsBtn: 'dlr_home_quickquote_purchasetickets_click',
        viewRatesBtn: 'dlr_home_quickquote_viewrates_click'
    },
    default: {
        mobileToggle: 'home_quickquote_buildyourvacation_expand',
        purchaseTicketsBtn: 'home_quickquote_purchasetickets_click',
        viewRatesBtn: 'home_quickquote_viewrates_click'
    }
};
const PARTY_MIX_DEFAULTS = {
    maxPartySize: 12,
    adultCount: 2,
    childCount: 0,
    childAgePlaceholder: '-',
    childAgeLabel: "Age of Children at Time of Travel"
};
const DROPDOWN_FIELDS = [
    'resort',
    'shopFor',
    'tickets',
    'departAirport',
    'returnAirport',
    'travelClass'
];

const wdprCounterCss = ":host{--font-family-base:var(--font-family-base-theme, InspireTWDC);--font-family-light:var(--font-family-light-theme, InspireTWDCLight);--font-family-heavy:var(--font-family-heavy-theme, InspireTWDCHeavy);--font-family-black:var(--font-family-black-theme, InspireTWDCBlack);--font-family-medium:var(--font-family-medium-theme, InspireTWDCMedium);--font-family-roman:var(--font-family-roman-theme, InspireTWDCRoman);--font-family-book:var(--font-family-book-theme, InspireTWDCBook);--font-weight-light:var(--font-weight-light-theme, 200);--font-weight-heavy:var(--font-weight-heavy-theme, 700);--font-weight-black:var(--font-weight-black-theme, 900);--font-weight-medium:var(--font-weight-medium-theme, 500);--font-weight-roman:var(--font-weight-roman-theme, 400);--font-weight-book:var(--font-weight-book-theme, 400);--font50-line-height:var(--font50-line-height-theme, 60px);--font40-line-height:var(--font40-line-height-theme, 50px);--font36-line-height:var(--font36-line-height-theme, 48px);--font28-line-height:var(--font28-line-height-theme, 36px);--font24-line-height:var(--font24-line-height-theme, 32px);--font20-line-height:var(--font20-line-height-theme, 28px);--font18-line-height:var(--font18-line-height-theme, 26px);--font16-line-height:var(--font16-line-height-theme, 24px);--font14-line-height:var(--font14-line-height-theme, 20px);--font12-line-height:var(--font12-line-height-theme, 20px)}:host{--font-base:{\n    font-family: var(--font-family-base)}; --font-light:{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}; --font-heavy:{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}; --font-black:{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}; --font-medium:{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}; --font-roman:{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}; --font-book:{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}; --font50:{font-size:50px;line-height:var(--font50-line-height)}; --font40:{font-size:40px;line-height:var(--font40-line-height)}; --font36:{font-size:36px;line-height:var(--font36-line-height)}; --font28:{font-size:28px;line-height:var(--font28-line-height)}; --font24:{font-size:24px;line-height:var(--font24-line-height)}; --font20:{font-size:20px;line-height:var(--font20-line-height)}; --font18:{font-size:18px;line-height:var(--font18-line-height)}; --font16:{font-size:16px;line-height:var(--font16-line-height)}; --font14:{font-size:14px;line-height:var(--font14-line-height)}; --font12:{font-size:12px;line-height:var(--font12-line-height)}; } .font-base,:host{font-family:var(--font-family-base)}.light,.wdpr-counter #editableWrapper #editableInput,.wdpr-counter{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}.heavy{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}.black{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}.medium{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}.roman{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}.book{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.font50{font-size:50px;line-height:var(--font50-line-height)}.font40{font-size:40px;line-height:var(--font40-line-height)}.font36{font-size:36px;line-height:var(--font36-line-height)}.font28{font-size:28px;line-height:var(--font28-line-height)}.font24{font-size:24px;line-height:var(--font24-line-height)}.font20{font-size:20px;line-height:var(--font20-line-height)}.font18{font-size:18px;line-height:var(--font18-line-height)}.font16{font-size:16px;line-height:var(--font16-line-height)}.font14{font-size:14px;line-height:var(--font14-line-height)}.font12{font-size:12px;line-height:var(--font12-line-height)}.font-lg-1{font-size:50px;line-height:var(--font50-line-height)}.font-lg-2{font-size:40px;line-height:var(--font40-line-height)}.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}@media only screen and (min-width: 481px) and (max-width: 1179.98px){.font-lg-1,.font-lg-2,.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}@media only screen and (max-width: 480.98px){.font-lg-1,.font-lg-2,.font-md-1,.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}:host{font-family:var(--font-family-base)}:host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}:host{--primary:var(--primary-theme);--primary-dark:var(--primary-dark-theme);--primary-background:var(--primary-background-theme);--primary-other:var(--primary-other-theme);--primary-disabled:var(--primary-disabled-theme);--primary-message:var(--primary-message-theme);--primary-alert:var(--primary-alert-theme);--primary-gradient-from:var(--primary-gradient-from-theme);--primary-gradient-to:var(--primary-gradient-to-theme);--secondary-focus:var(--secondary-focus-theme);--secondary-hover:var(--secondary-hover-theme);--secondary-disabled:var(--secondary-disabled-theme);--secondary-background:var(--secondary-background-theme);--secondary-other-dark:var(--secondary-other-dark-theme);--secondary-other-hover:var(--secondary-other-hover-theme);--secondary-other-disabled:var(--secondary-other-disabled-theme);--secondary-other-good-to-go:var(--secondary-other-good-to-go-theme);--secondary-message:var(--secondary-message-theme);--secondary-message-detail:var(--secondary-message-detail-theme);--secondary-message-chrome:var(--secondary-message-chrome-theme);--secondary-gradient-from:var(--secondary-gradient-from-theme);--secondary-gradient-to:var(--secondary-gradient-to-theme);--secondary-inactive:var(--secondary-inactive-theme);--reversed-hover:var(--reversed-hover-theme);--link:var(--link-theme);--outline-color:var(--outline-color-theme);--outline-style:var(--outline-style-theme);--outline-width:var(--outline-width-theme)}.primary{color:var(--primary)}.primary:hover{color:var(--secondary-hover)}.primary[disabled]{color:var(--secondary-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.primary-dark{color:var(--primary-dark)}.primary-other{color:var(--primary-other)}.primary-message{color:var(--primary-message)}.primary-alert{color:var(--primary-alert)}.background-primary-background{background-color:var(--primary-background)}.background-primary{background-color:var(--primary)}.background-primary-dark{background-color:var(--primary-dark)}.background-primary-other{background-color:var(--primary-other)}.background-primary-message{background-color:var(--primary-message)}.background-primary-alert{background-color:var(--primary-alert)}.background-primary-gradient{background:linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to))}.secondary-other-dark{color:var(--secondary-other-dark)}.secondary-other-dark:hover{color:var(--secondary-other-hover)}.secondary-other-dark[disabled]{color:var(--secondary-other-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.secondary-other-good-to-go{color:var(--secondary-other-good-to-go)}.secondary-message{color:var(--secondary-message)}.secondary-message-detail{color:var(--secondary-message-detail)}.secondary-message-chrome{color:var(--secondary-message-chrome)}.background-secondary{background-color:var(--secondary-background)}.background-secondary-focus{background-color:var(--secondary-focus)}.background-secondary-hover{background-color:var(--secondary-hover)}.background-secondary-disabled{background-color:var(--secondary-disabled)}.background-secondary-other-hover{background-color:var(--secondary-other-hover)}.background-secondary-other-disabled{background-color:var(--secondary-other-disabled)}.background-secondary-other-dark{background-color:var(--secondary-other-dark)}.background-secondary-other-good-to-go{background-color:var(--secondary-other-good-to-go)}.background-secondary-message{background-color:var(--secondary-message)}.background-secondary-inactive{background-color:var(--secondary-inactive)}.background-secondary-message-detail{background-color:var(--secondary-message-detail)}.background-secondary-message-chrome{background-color:var(--secondary-message-chrome)}.background-secondary-gradient{background:linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to))}a,.link{color:var(--link);text-decoration:none}a:link,a:visited,a:hover,a:active,.link:link,.link:visited,.link:hover,.link:active{color:var(--link)}a:hover,a:focus,.link:hover,.link:focus{text-decoration:underline}.link{color:var(--link);cursor:pointer}a:focus,.link:focus,button:focus{outline-color:var(--outline-color);outline-style:var(--outline-style);outline-width:var(--outline-width)}:host{display:block}:host([value-only]) .button{display:none}.wdpr-counter{width:100%;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;align-items:center;align-content:stretch;font-size:inherit;line-height:1em}.wdpr-counter .counter{color:var(--counter-color, var(--primary-dark));-webkit-text-fill-color:var(--counter-color, var(--primary-dark));line-height:1em;text-align:center;vertical-align:middle;width:100%}.wdpr-counter .counter.non-editable{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:flex;justify-content:center;flex-basis:auto}.wdpr-counter #editableWrapper{display:flex;align-items:center;justify-content:center;flex-grow:1;height:1em;box-shadow:0 1px 3px 0 var(--counter-editable-wrapper-box-shadow-color, var(--secondary-message-detail));box-sizing:border-box;border:1px solid transparent;margin:0 2px 3px;border-radius:0.15em;font:inherit;position:relative}.wdpr-counter #editableWrapper #editableInput{border:none;padding:0;-moz-appearance:textfield;font-size:inherit}.wdpr-counter #editableWrapper #editableInput::-webkit-outer-spin-button,.wdpr-counter #editableWrapper #editableInput::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.wdpr-counter #editableWrapper #editableInput[disabled]{background:none;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.wdpr-counter #editableWrapper #editableInput:focus{outline-width:var(--wdpr-counter-focus-outline-width, 2px);outline-style:var(--wdpr-counter-focus-outline-style, solid);outline-color:var(--wdpr-counter-focus-outline-color, var(--blue-900))}.wdpr-counter .button{background:transparent;border:0;padding:0;cursor:pointer;box-sizing:border-box;padding:0;flex-grow:0;flex-shrink:0;flex-basis:0;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.wdpr-counter .button .icon{color:var(--counter-icon-color, var(--primary));background-color:var(--counter-icon-background-color, white);border:1px solid;border-color:var(--counter-icon-background-color, var(--primary));border-radius:var(--counter-icon-border-radius, 20px);height:var(--counter-icon-height, 40px);width:var(--counter-icon-width, 40px);display:inline-block;top:0;left:0}.wdpr-counter .button .icon #minus{fill:var(--counter-icon-color, var(--primary))}.wdpr-counter .button .icon #plus{fill:var(--counter-icon-color, var(--primary))}.wdpr-counter .button:hover:not([disabled]) .icon{background-color:var(--counter-icon-background-hover-color, white);border-color:var(--counter-icon-background-hover-color, var(--secondary-hover))}.wdpr-counter .button:hover:not([disabled]) .icon #minus{fill:var(--counter-icon-hover-color, var(--secondary-hover))}.wdpr-counter .button:hover:not([disabled]) .icon #plus{fill:var(--counter-icon-hover-color, var(--secondary-hover))}.wdpr-counter .button:active:not([disabled]) .icon{background-color:var(--counter-icon-background-active-color, white);border-color:var(--counter-icon-background-active-color, var(--secondary-hover))}.wdpr-counter .button:active:not([disabled]) .icon #minus{fill:var(--counter-icon-active-color, var(--secondary-hover))}.wdpr-counter .button:active:not([disabled]) .icon #plus{fill:var(--counter-icon-active-color, var(--secondary-hover))}.wdpr-counter .button:focus:not([disabled]){outline-color:initial;outline-color:-webkit-focus-ring-color;outline-style:auto}.wdpr-counter .button[disabled]{pointer-events:none}.wdpr-counter .button[disabled] .icon,.wdpr-counter .button[disabled]:focus .icon,.wdpr-counter .button[disabled]:hover .icon{color:var(--counter-icon-disabled-color, var(--primary-disabled));background-color:var(--counter-icon-background-disabled-color, white);border-color:var(--counter-icon-background-disabled-color, var(--primary-disabled));cursor:default}.wdpr-counter .button[disabled] .icon #minus,.wdpr-counter .button[disabled]:focus .icon #minus,.wdpr-counter .button[disabled]:hover .icon #minus{fill:var(--counter-icon-disabled-color, var(--primary-disabled))}.wdpr-counter .button[disabled] .icon #plus,.wdpr-counter .button[disabled]:focus .icon #plus,.wdpr-counter .button[disabled]:hover .icon #plus{fill:var(--counter-icon-disabled-color, var(--primary-disabled))}.hidden,[hidden]{display:none !important}.visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;outline:0;-webkit-appearance:none;-moz-appearance:none}#invalid-icon{color:var(--orange-700, var(--primary-alert)) !important;top:5px;font-size:16px;position:relative}#counter-aria-description{color:var(--orange-700, var(--primary-alert)) !important;top:3px;left:2px;position:relative;font-size:16px;margin:6px 0px 0px 0px}.error-div{width:max-content}";

const WdprCounter$1 = /*@__PURE__*/ proxyCustomElement(class WdprCounter extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.updateDispatcher = createEvent(this, "updated", 3);
        this.invalidValueDispatcher = createEvent(this, "invalidValue", 7);
        /**
         * Increment the counter
         */
        this._increment = (_event) => {
            this.valid = true;
            this.value = Number(this.value) + 1;
        };
        /**
         * Decrement the counter
         */
        this._decrement = (_event) => {
            this.valid = true;
            this.value = Number(this.value) - 1;
        };
        /**
         *
         * @param event
         */
        this._onKeydown = (event) => {
            // backspace, tab, supr, left-right and up/down arrows
            let acceptedKeys = [8, 9, 46, 33, 34, 35, 36, 37, 38, 39, 40];
            let pressedKey = event.which || event.keyCode;
            // numeric event codes for number keys and numpad ones
            let isNumber = pressedKey >= 48 &&
                pressedKey <= 57 ||
                pressedKey >= 96 &&
                    pressedKey <= 105;
            // if arrow up key is pressed and the plus button is enabled
            if (pressedKey === 38 && !this.plusDisabled) {
                this.value += 1;
            }
            else if (pressedKey === 40) {
                this.value -= 1;
            }
            // if page up or page down
            if (pressedKey === 33) {
                this.value += 5;
            }
            else if (pressedKey === 34) {
                this.value -= 5;
            }
            // if End or Home key is pressed
            if (pressedKey === 35) {
                this.value = this.upperLimit;
            }
            else if (pressedKey === 36) {
                this.value = this.lowerLimit;
            }
            // if the key is not a number and not in the accepted keys array,
            // or is a number pressed with shift key, (except shift+tab) reject
            let neitherNumberNorAcceptedKey = !isNumber && acceptedKeys.indexOf(pressedKey) === -1;
            if (neitherNumberNorAcceptedKey || (event.shiftKey && pressedKey !== 9)) {
                event.returnValue = false;
                event.preventDefault();
            }
        };
        /**
         * Update value after editable counter is changed
         * @param event
         */
        this._onChange = (event) => {
            var currentValue = this.value;
            if (event.target.value == "" || event.target.value < this.lowerLimit) {
                this.valid = false;
                this.showError(this.valid);
                if (this.errorMessage == '') {
                    this.errorMessage = "The value must be between " + this.lowerLimit + " and " + this.upperLimit + ".";
                }
            }
            else if (event.target.value > this.upperLimit) {
                this.valid = false;
                this.showError(this.valid);
                if (this.errorMessage == '') {
                    this.errorMessage = "The value must be between " + this.lowerLimit + " and " + this.upperLimit + ".";
                }
            }
            else {
                this.valid = true;
                if (this.value == event.target.value) { // int vs string comparison, using == on purpose here (rather than ===)
                    // fire event when value switches back to valid from a previously invalid one
                    this._dispatchUpdate({ value: this.value, id: this.fieldName, fieldName: this.fieldName });
                }
                this.value = event.target.value;
            }
            // fire event when value is invalid
            if (!this.valid) {
                this._dispatchInvalidValue({ id: this.fieldName, fieldName: this.fieldName, errorMessage: this.errorMessage });
                if (this.resetAfterInvalid) {
                    this.el.shadowRoot.querySelector('#editableInput').value = currentValue.toString();
                    this.value = currentValue;
                }
            }
        };
        this.value = 0;
        this.fieldName = undefined;
        this.incrementLabel = 'Add One Item';
        this.decrementLabel = 'Remove One Item';
        this.upperLimit = 10;
        this.lowerLimit = 0;
        this.errorMessage = '';
        this.valid = true;
        this.messageDuration = 4500;
        this.disabled = false;
        this.minusDisabled = false;
        this.plusDisabled = false;
        this.valueOnly = false;
        this.resetAfterInvalid = false;
    }
    /**
     * Watcher to detect changes to value
     *
     * @param newValue number
     * @param oldValue number
     */
    watchHandler(newValue, oldValue) {
        this._countChanged(newValue, oldValue);
    }
    /**
     * Dispatcher for updated event
     * @param details the value, fieldName, and id of the counter
     */
    _dispatchUpdate(details) {
        this.updateDispatcher.emit(details);
    }
    /**
     * Dispatcher for invalidValue event
     * @param details the fieldName, errorMessage, and id of the counter
     */
    _dispatchInvalidValue(details) {
        this.invalidValueDispatcher.emit(details);
    }
    /* Disables the buttons
    * @param  {Int}  value = current value
    * @param  {Int}  limit = limit passed in
    * @param  {Boolean} isDisabled property
    * @param  {Boolean} individualDisabled
    * @return {Boolean} result of the comparator
    */
    _isDisabled(value, limit, disabled, individualDisabled) {
        return individualDisabled || value === limit || disabled;
    }
    /**
     * Event triggered when the count updates
     * @param  number newVal
     * @param  number oldVal
     */
    _countChanged(newVal, oldVal) {
        if (typeof oldVal === 'undefined') {
            return;
        }
        if (newVal > oldVal) {
            if (this.value < this.upperLimit) {
                this.value = Number(this.value);
            }
            else {
                this.value = this.upperLimit;
            }
        }
        else if (newVal < oldVal) {
            if (this.value > this.lowerLimit) {
                this.value = Number(this.value);
            }
            else {
                this.value = this.lowerLimit;
            }
        }
        else {
            return;
        }
        // Trigger aria alert
        var alertEl = this.el.shadowRoot.querySelector("[id='alert']");
        let newMinusState = this._isDisabled(newVal, this.lowerLimit, this.disabled, this.minusDisabled);
        let newPlusState = this._isDisabled(newVal, this.upperLimit, this.disabled, this.plusDisabled);
        alertEl.innerHTML = "quantity " + this.value;
        if (newMinusState != this._isDisabled(oldVal, this.lowerLimit, this.disabled, this.minusDisabled)) {
            alertEl.innerHTML += ". minus button is now " + (newMinusState ? "disabled" : "enabled");
        }
        if (newPlusState != this._isDisabled(oldVal, this.upperLimit, this.disabled, this.plusDisabled)) {
            alertEl.innerHTML += ". plus button is now " + (newPlusState ? "disabled" : "enabled");
        }
        this._dispatchUpdate({ value: this.value, id: this.fieldName, fieldName: this.fieldName });
    }
    /**
     * Add outline triggered by keypress
     * @param {Event} event
     */
    _addOutline(event) {
        event.currentTarget.classList.add('focus');
    }
    /**
     * Remove outline triggered by blur
     * @param {Event} event
     */
    _removeOutline(event) {
        event.currentTarget.classList.remove('focus');
    }
    computeCustomErrorMessage(errorMessage) {
        return (errorMessage.trim() !== '') ? errorMessage : '';
    }
    componentWillLoad() {
        this.el.addEventListener('touchstart', function () { }, { passive: true });
    }
    /**
     * Boolean determining whether error message should be shown
     * @return {boolean}
     */
    showError(valid) {
        return !valid;
    }
    _getAriaInvalid(valid) {
        return !valid ? 'true' : 'false';
    }
    render() {
        return (h(Host, null, h("div", { class: "wdpr-counter" }, h("button", { id: "minusButton", class: "decrement button", "aria-label": this.decrementLabel, onClick: this._decrement, "on-touchstart": this._decrement, "on-keyup": this._addOutline, "on-blur": this._removeOutline, "on-touchend": e => e.returnValue = false, disabled: this._isDisabled(this.value, this.lowerLimit, this.disabled, this.minusDisabled), tabindex: "-1" }, h("svg", { class: "icon", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h("g", { id: "minus", transform: "translate(6.000000, 11.000000)" }, h("rect", { id: "Rectangle-21", x: "0", y: "0", width: "12", height: "2", rx: "1" }))))), h("div", { id: "editableWrapper" }, h("span", null, h("input", { id: "editableInput", type: "number", "on-keydown": this._onKeydown, class: "counter", onChange: this._onChange, disabled: this.disabled, min: this.lowerLimit, max: this.upperLimit, "aria-label": "Quantity", "aria-invalid": this._getAriaInvalid(this.valid), value: this.value }))), h("span", { class: "visually-hidden", id: "alert", "aria-live": "assertive", "aria-atomic": "true", "inner-h-t-m-l": '' }), h("button", { id: "plusButton", class: "increment button", onClick: this._increment, "aria-label": this.incrementLabel, disabled: this._isDisabled(this.value, this.upperLimit, this.disabled, this.plusDisabled), "on-touchstart": this._increment, "on-keyup": this._addOutline, "on-blur": this._removeOutline, "on-touchend": e => e.returnValue = false, tabindex: "-1" }, h("svg", { class: "icon", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h("g", { id: "plus", transform: "translate(6.000000, 6.000000)" }, h("g", null, h("rect", { id: "Rectangle-18", x: "0", y: "5", width: "12", height: "2", rx: "1" }), h("path", { d: "M1,5 L11,5 C11.5522847,5 12,5.44771525 12,6 C12,6.55228475 11.5522847,7 11,7 L1,7 C0.44771525,7 6.76353751e-17,6.55228475 0,6 C-6.76353751e-17,5.44771525 0.44771525,5 1,5 Z", id: "Rectangle-19", transform: "translate(6.000000, 6.000000) rotate(-270.000000) translate(-6.000000, -6.000000) " })))))), h("input", { type: "hidden", id: this.fieldName, name: this.fieldName, value: this.value })), this.showError(this.valid)
            ?
                h(Fragment, null, h("div", { class: "error-div" }, h("i", { id: "invalid-icon", class: "di di-alert", role: "img" }), h("span", { id: "counter-aria-description" }, this.computeCustomErrorMessage(this.errorMessage))))
            : ''));
    }
    get el() { return this; }
    static get watchers() { return {
        "value": ["watchHandler"]
    }; }
    static get style() { return wdprCounterCss; }
}, [1, "wdpr-counter", {
        "value": [1538],
        "fieldName": [1, "field-name"],
        "incrementLabel": [1, "increment-label"],
        "decrementLabel": [1, "decrement-label"],
        "upperLimit": [2, "upper-limit"],
        "lowerLimit": [2, "lower-limit"],
        "errorMessage": [1025, "error-message"],
        "valid": [1028],
        "messageDuration": [2, "message-duration"],
        "disabled": [4],
        "minusDisabled": [4, "minus-disabled"],
        "plusDisabled": [4, "plus-disabled"],
        "valueOnly": [516, "value-only"],
        "resetAfterInvalid": [4, "reset-after-invalid"]
    }, undefined, {
        "value": ["watchHandler"]
    }]);
function defineCustomElement$1$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-counter"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-counter":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprCounter$1);
            }
            break;
    } });
}
defineCustomElement$1$1();

const wdprMessagesCss = ":host{--font-family-base:var(--font-family-base-theme, InspireTWDC);--font-family-light:var(--font-family-light-theme, InspireTWDCLight);--font-family-heavy:var(--font-family-heavy-theme, InspireTWDCHeavy);--font-family-black:var(--font-family-black-theme, InspireTWDCBlack);--font-family-medium:var(--font-family-medium-theme, InspireTWDCMedium);--font-family-roman:var(--font-family-roman-theme, InspireTWDCRoman);--font-family-book:var(--font-family-book-theme, InspireTWDCBook);--font-weight-light:var(--font-weight-light-theme, 200);--font-weight-heavy:var(--font-weight-heavy-theme, 700);--font-weight-black:var(--font-weight-black-theme, 900);--font-weight-medium:var(--font-weight-medium-theme, 500);--font-weight-roman:var(--font-weight-roman-theme, 400);--font-weight-book:var(--font-weight-book-theme, 400);--font50-line-height:var(--font50-line-height-theme, 60px);--font40-line-height:var(--font40-line-height-theme, 50px);--font36-line-height:var(--font36-line-height-theme, 48px);--font28-line-height:var(--font28-line-height-theme, 36px);--font24-line-height:var(--font24-line-height-theme, 32px);--font20-line-height:var(--font20-line-height-theme, 28px);--font18-line-height:var(--font18-line-height-theme, 26px);--font16-line-height:var(--font16-line-height-theme, 24px);--font14-line-height:var(--font14-line-height-theme, 20px);--font12-line-height:var(--font12-line-height-theme, 20px)}:host{--font-base:{\n    font-family: var(--font-family-base)}; --font-light:{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}; --font-heavy:{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}; --font-black:{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}; --font-medium:{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}; --font-roman:{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}; --font-book:{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}; --font50:{font-size:50px;line-height:var(--font50-line-height)}; --font40:{font-size:40px;line-height:var(--font40-line-height)}; --font36:{font-size:36px;line-height:var(--font36-line-height)}; --font28:{font-size:28px;line-height:var(--font28-line-height)}; --font24:{font-size:24px;line-height:var(--font24-line-height)}; --font20:{font-size:20px;line-height:var(--font20-line-height)}; --font18:{font-size:18px;line-height:var(--font18-line-height)}; --font16:{font-size:16px;line-height:var(--font16-line-height)}; --font14:{font-size:14px;line-height:var(--font14-line-height)}; --font12:{font-size:12px;line-height:var(--font12-line-height)}; } .font-base{font-family:var(--font-family-base)}.light{font-family:var(--font-family-light);font-weight:var(--font-weight-light)}.heavy{font-family:var(--font-family-heavy);font-weight:var(--font-weight-heavy)}.black{font-family:var(--font-family-black);font-weight:var(--font-weight-black)}.medium{font-family:var(--font-family-medium);font-weight:var(--font-weight-medium)}.roman{font-family:var(--font-family-roman);font-weight:var(--font-weight-roman)}.book{font-family:var(--font-family-book);font-weight:var(--font-weight-book)}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.font50{font-size:50px;line-height:var(--font50-line-height)}.font40{font-size:40px;line-height:var(--font40-line-height)}.font36{font-size:36px;line-height:var(--font36-line-height)}.font28{font-size:28px;line-height:var(--font28-line-height)}.font24{font-size:24px;line-height:var(--font24-line-height)}.font20{font-size:20px;line-height:var(--font20-line-height)}.font18{font-size:18px;line-height:var(--font18-line-height)}.font16,:host{font-size:16px;line-height:var(--font16-line-height)}.font14{font-size:14px;line-height:var(--font14-line-height)}.font12{font-size:12px;line-height:var(--font12-line-height)}.font-lg-1{font-size:50px;line-height:var(--font50-line-height)}.font-lg-2{font-size:40px;line-height:var(--font40-line-height)}.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}@media only screen and (min-width: 481px) and (max-width: 1179.98px){.font-lg-1,.font-lg-2,.font-md-1{font-size:36px;line-height:var(--font36-line-height)}.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}@media only screen and (max-width: 480.98px){.font-lg-1,.font-lg-2,.font-md-1,.font-sm-1{font-size:28px;line-height:var(--font28-line-height)}.font-sm-2{font-size:24px;line-height:var(--font24-line-height)}.font-sm-3{font-size:20px;line-height:var(--font20-line-height)}.font-sm-4{font-size:18px;line-height:var(--font18-line-height)}.font-sm-5{font-size:16px;line-height:var(--font16-line-height)}.font-sm-6{font-size:14px;line-height:var(--font14-line-height)}}:host{font-family:var(--font-family-base)}:host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}:host{--primary:var(--primary-theme);--primary-dark:var(--primary-dark-theme);--primary-background:var(--primary-background-theme);--primary-other:var(--primary-other-theme);--primary-disabled:var(--primary-disabled-theme);--primary-message:var(--primary-message-theme);--primary-alert:var(--primary-alert-theme);--primary-gradient-from:var(--primary-gradient-from-theme);--primary-gradient-to:var(--primary-gradient-to-theme);--secondary-focus:var(--secondary-focus-theme);--secondary-hover:var(--secondary-hover-theme);--secondary-disabled:var(--secondary-disabled-theme);--secondary-background:var(--secondary-background-theme);--secondary-other-dark:var(--secondary-other-dark-theme);--secondary-other-hover:var(--secondary-other-hover-theme);--secondary-other-disabled:var(--secondary-other-disabled-theme);--secondary-other-good-to-go:var(--secondary-other-good-to-go-theme);--secondary-message:var(--secondary-message-theme);--secondary-message-detail:var(--secondary-message-detail-theme);--secondary-message-chrome:var(--secondary-message-chrome-theme);--secondary-gradient-from:var(--secondary-gradient-from-theme);--secondary-gradient-to:var(--secondary-gradient-to-theme);--secondary-inactive:var(--secondary-inactive-theme);--reversed-hover:var(--reversed-hover-theme);--link:var(--link-theme);--outline-color:var(--outline-color-theme);--outline-style:var(--outline-style-theme);--outline-width:var(--outline-width-theme)}.primary{color:var(--primary)}.primary:hover{color:var(--secondary-hover)}.primary[disabled]{color:var(--secondary-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.primary-dark{color:var(--primary-dark)}.primary-other{color:var(--primary-other)}.primary-message{color:var(--primary-message)}.primary-alert{color:var(--primary-alert)}.background-primary-background{background-color:var(--primary-background)}.background-primary{background-color:var(--primary)}.background-primary-dark{background-color:var(--primary-dark)}.background-primary-other{background-color:var(--primary-other)}.background-primary-message{background-color:var(--primary-message)}.background-primary-alert{background-color:var(--primary-alert)}.background-primary-gradient{background:linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to))}.secondary-other-dark{color:var(--secondary-other-dark)}.secondary-other-dark:hover{color:var(--secondary-other-hover)}.secondary-other-dark[disabled]{color:var(--secondary-other-disabled);cursor:not-allowed;-ms-user-select:none;user-select:none}.secondary-other-good-to-go{color:var(--secondary-other-good-to-go)}.secondary-message{color:var(--secondary-message)}.secondary-message-detail{color:var(--secondary-message-detail)}.secondary-message-chrome{color:var(--secondary-message-chrome)}.background-secondary{background-color:var(--secondary-background)}.background-secondary-focus{background-color:var(--secondary-focus)}.background-secondary-hover{background-color:var(--secondary-hover)}.background-secondary-disabled{background-color:var(--secondary-disabled)}.background-secondary-other-hover{background-color:var(--secondary-other-hover)}.background-secondary-other-disabled{background-color:var(--secondary-other-disabled)}.background-secondary-other-dark{background-color:var(--secondary-other-dark)}.background-secondary-other-good-to-go{background-color:var(--secondary-other-good-to-go)}.background-secondary-message{background-color:var(--secondary-message)}.background-secondary-inactive{background-color:var(--secondary-inactive)}.background-secondary-message-detail{background-color:var(--secondary-message-detail)}.background-secondary-message-chrome{background-color:var(--secondary-message-chrome)}.background-secondary-gradient{background:linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to))}a,.link{color:var(--link);text-decoration:none}a:link,a:visited,a:hover,a:active,.link:link,.link:visited,.link:hover,.link:active{color:var(--link)}a:hover,a:focus,.link:hover,.link:focus{text-decoration:underline}.link{color:var(--link);cursor:pointer}a:focus,.link:focus,button:focus{outline-color:var(--outline-color);outline-style:var(--outline-style);outline-width:var(--outline-width)}:host{display:flex;flex-direction:column;text-align:left;margin-bottom:10px}.wrapper{flex-shrink:1}.wrapper .message-container{display:flex}.wrapper .message-container i{font-size:var(--wdpr-messages-icon-font-size, 20px);font-weight:normal;margin:var(--wdpr-messages-icon-margin, 0px)}.wrapper .message-container .icon{margin-right:6px}.wrapper .message-container .message{font-family:var(--wdpr-messages-font-family, var(--font-family-heavy));font-weight:var(--wdpr-messages-font-weight, var(--font-weight-heavy));max-width:800px}";

const WdprMessages$1 = /*@__PURE__*/ proxyCustomElement(class WdprMessages extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.values = [];
        this.hidedi = undefined;
        this.di = '';
        this.type = 'error';
        this.iconAriaLabel = '';
    }
    /**
     * Add CSS class based on type
     */
    _handleTypeClass() {
        if (this.type === 'error') {
            return 'primary-alert';
        }
        else if (this.type === 'success') {
            return 'primary-other';
        }
        else {
            return 'primary-dark';
        }
    }
    /**
     * Add correct icon class based on type and custom icon
     */
    _handleClassIcon() {
        if (this.type === 'error') {
            return (this.di != '' ? this.di : 'di-alert');
        }
        else if (this.type === 'success') {
            return (this.di != '' ? this.di : 'di-checkmark');
        }
        else {
            return '';
        }
    }
    /**
     * Hide the icon if not error or success
     */
    componentWillLoad() {
        if (this.type != 'error' && this.type != 'success') {
            this.hidedi = true;
        }
    }
    render() {
        return (h("div", { class: "wrapper" }, this.values.map((value) => h("div", { class: "message-container " + this._handleTypeClass() }, this.hidedi
            ? ''
            : h("i", { id: "work", class: "di " + this._handleClassIcon(), "aria-label": this.iconAriaLabel, role: "img" }), h("span", { class: "message " + this._handleTypeClass() }, value)))));
    }
    static get style() { return wdprMessagesCss; }
}, [1, "wdpr-messages", {
        "values": [16],
        "hidedi": [1028],
        "di": [1],
        "type": [1],
        "iconAriaLabel": [1, "icon-aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-messages"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-messages":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprMessages$1);
            }
            break;
    } });
}
defineCustomElement$1();

class PartyMix {
    isMaxPartySize(maxPartySize, adultCount, childCount) {
        return maxPartySize <= (adultCount + childCount);
    }
    exceedsMaxPartySize(maxPartySize, adultCount, childCount) {
        return (adultCount + childCount) > maxPartySize;
    }
    parseChildAgeValue(selectionValue) {
        let childAgeValue = parseInt(selectionValue);
        if (!childAgeValue) {
            if (selectionValue === PARTY_MIX_DEFAULTS.childAgePlaceholder) {
                childAgeValue = undefined;
            }
            else {
                // Age value should be 1 for 'Infant' selection in any language
                childAgeValue = 1;
            }
        }
        return childAgeValue;
    }
    modelChildAges(childAges) {
        const modeledChildAges = childAges.map(age => {
            if (!lodash.isNumber(Number(age)) && age !== PARTY_MIX_DEFAULTS.childAgePlaceholder) {
                age = "1";
            }
            return {
                "key": age,
                "value": age
            };
        });
        return modeledChildAges;
    }
    ;
}

const wdprPartyMixSelectCss = ":host{--icon-font-family:var(--icon-font-family-theme, \"pepmdx\")}.di{font-family:var(--icon-font-family, \"pepmdx\") !important;font-style:normal;font-size:inherit}.di50{font-size:50px}.di40{font-size:40px}.di36{font-size:36px}.di28{font-size:28px}.di24{font-size:24px}.di20{font-size:20px}.di18{font-size:18px}.di16{font-size:16px}.di14{font-size:14px}.di12{font-size:12px}.di10{font-size:10px}.di-disney-resort::before,.di-E001::before{content:\"\\e001\"}.di-california-adventure::before,.di-E002::before{content:\"\\e002\"}.di-disney-paris::before,.di-E003::before{content:\"\\e003\"}.di-shanghai-disney-resort::before,.di-E004::before{content:\"\\e004\"}.di-hong-kong-disney::before,.di-E005::before{content:\"\\e005\"}.di-tokyo-disney::before,.di-E006::before{content:\"\\e006\"}.di-aulani-resort-hawaii::before,.di-E007::before{content:\"\\e007\"}.di-adventure-by-disney::before,.di-E008::before{content:\"\\e008\"}.di-disney-park-generic-castle::before,.di-E009::before{content:\"\\e009\"}.di-leadership::before,.di-E00A::before{content:\"\\e00a\"}.di-selection-training::before,.di-E00B::before{content:\"\\e00b\"}.di-quality-service::before,.di-E00C::before{content:\"\\e00c\"}.di-brand-royalty::before,.di-E00D::before{content:\"\\e00d\"}.di-creativity-innovate::before,.di-E00E::before{content:\"\\e00e\"}.di-business-excellence::before,.di-E00F::before{content:\"\\e00f\"}.di-medical-excellence::before,.di-E010::before{content:\"\\e010\"}.di-catalogs::before,.di-E011::before{content:\"\\e011\"}.di-disney-park::before,.di-E012::before{content:\"\\e012\"}.di-disneyland-resort::before,.di-E013::before{content:\"\\e013\"}.di-city-hall-services::before,.di-E014::before{content:\"\\e014\"}.di-hkdl-magic-access::before,.di-E015::before{content:\"\\e015\"}.di-downtown-disney::before,.di-E016::before{content:\"\\e016\"}.di-wedding-engagements::before,.di-E017::before{content:\"\\e017\"}.di-weddings-ever-after-blog::before,.di-E018::before{content:\"\\e018\"}.di-weddings-bridal-boutique::before,.di-E019::before{content:\"\\e019\"}.di-shdr-disneytown::before,.di-E01A::before{content:\"\\e01a\"}.di-shdr-wishing-star-park::before,.di-E01B::before{content:\"\\e01b\"}.di-shop-disney-parks-app::before,.di-E01C::before{content:\"\\e01c\"}.di-shop-disney-parks-bag::before,.di-E01D::before{content:\"\\e01d\"}.di-shop-disney-bag::before,.di-E01E::before{content:\"\\e01e\"}.di-style-guide::before,.di-E020::before{content:\"\\e020\"}.di-star-wars::before,.di-E021::before{content:\"\\e021\"}.di-sw-galaxys-edge-hub::before,.di-E022::before{content:\"\\e022\"}.di-rundisney-medals::before,.di-E023::before{content:\"\\e023\"}.di-rundisney-shirts::before,.di-E024::before{content:\"\\e024\"}.di-rundisney-snacks::before,.di-E025::before{content:\"\\e025\"}.di-disneyland-calender::before,.di-E026::before{content:\"\\e026\"}.di-california-adventure-calender::before,.di-E027::before{content:\"\\e027\"}.di-genie-product::before,.di-E028::before{content:\"\\e028\"}.di-all-parks-and-resorts::before,.di-E040::before{content:\"\\e040\"}.di-magic-kingdom::before,.di-E041::before{content:\"\\e041\"}.di-epcot::before,.di-E042::before{content:\"\\e042\"}.di-animal-kingdom::before,.di-E043::before{content:\"\\e043\"}.di-hollywood-studios::before,.di-E044::before{content:\"\\e044\"}.di-typhoon-lagoon::before,.di-E045::before{content:\"\\e045\"}.di-blizzard-beach::before,.di-E046::before{content:\"\\e046\"}.di-disney-springs::before,.di-E047::before{content:\"\\e047\"}.di-espn-wide-world-sports::before,.di-E048::before{content:\"\\e048\"}.di-resorts::before,.di-E049::before{content:\"\\e049\"}.di-disney-beach-resorts::before,.di-E04A::before{content:\"\\e04a\"}.di-disney-boardwalk::before,.di-E04B::before{content:\"\\e04b\"}.di-all-categories::before,.di-E04C::before{content:\"\\e04c\"}.di-cirque-du-soleil-la-nouba::before,.di-E04D::before{content:\"\\e04d\"}.di-star-wars-galactic-starcruiser::before,.di-E04E::before{content:\"\\e04e\"}.di-disney-cruise-line::before,.di-E080::before{content:\"\\e080\"}.di-dcl-our-ships::before,.di-E081::before{content:\"\\e081\"}.di-dcl-destinations::before,.di-E082::before{content:\"\\e082\"}.di-dcl-onboard-fun::before,.di-E083::before{content:\"\\e083\"}.di-dcl-new-cruisers::before,.di-E084::before{content:\"\\e084\"}.di-dcl-port-adventures::before,.di-E085::before{content:\"\\e085\"}.di-app-instructions::before,.di-E086::before{content:\"\\e086\"}.di-featured-article::before,.di-E087::before{content:\"\\e087\"}.di-drink-of-the-day::before,.di-E088::before{content:\"\\e088\"}.di-view-folio::before,.di-E08A::before{content:\"\\e08a\"}.di-key-to-the-world::before,.di-E08B::before{content:\"\\e08b\"}.di-in-room-entertainment::before,.di-E08C::before{content:\"\\e08c\"}.di-ship-directory::before,.di-E08D::before{content:\"\\e08d\"}.di-theatre::before,.di-E08E::before{content:\"\\e08e\"}.di-disembarkation::before,.di-E08F::before{content:\"\\e08f\"}.di-wash-hands::before,.di-E094::before{content:\"\\e094\"}.di-security-notice::before,.di-E095::before{content:\"\\e095\"}.di-environmental-message::before,.di-E096::before{content:\"\\e096\"}.di-room-upgrade::before,.di-E098::before{content:\"\\e098\"}.di-castaway-club-member::before,.di-E09A::before{content:\"\\e09a\"}.di-dcl-open-house::before,.di-E09B::before{content:\"\\e09b\"}.di-stateroom-balcony::before,.di-E09F::before{content:\"\\e09f\"}.di-cart-empty::before,.di-E0C0::before{content:\"\\e0c0\"}.di-cart-full::before,.di-E0C1::before{content:\"\\e0c1\"}.di-tickets::before,.di-E0C2::before{content:\"\\e0c2\"}.di-fastpass-plus::before,.di-E0C3::before{content:\"\\e0c3\"}.di-fastpasses-set::before,.di-E0C4::before{content:\"\\e0c4\"}.di-fastpasses-copy-set::before,.di-E0C5::before{content:\"\\e0c5\"}.di-cancel-fastpasses::before,.di-E0C6::before{content:\"\\e0c6\"}.di-water-park::before,.di-E0C7::before{content:\"\\e0c7\"}.di-vacation-packages::before,.di-E0C8::before{content:\"\\e0c8\"}.di-personal-magic::before,.di-E0C9::before{content:\"\\e0c9\"}.di-florida-resident::before,.di-E0CA::before{content:\"\\e0ca\"}.di-disney-vacation-club-info::before,.di-E0CB::before{content:\"\\e0cb\"}.di-annual-passholder::before,.di-E0CC::before{content:\"\\e0cc\"}.di-us-military::before,.di-E0CD::before{content:\"\\e0cd\"}.di-special-offers-dollar-sign::before,.di-E0CE::before{content:\"\\e0ce\"}.di-booking-rooms-packages::before,.di-E0CF::before{content:\"\\e0cf\"}.di-old-fastpass::before,.di-E0D0::before{content:\"\\e0d0\"}.di-certificate::before,.di-E0D1::before{content:\"\\e0d1\"}.di-will-call-tickets::before,.di-E0D2::before{content:\"\\e0d2\"}.di-entrance-pass::before,.di-E0D3::before{content:\"\\e0d3\"}.di-guest-pass::before,.di-E0D4::before{content:\"\\e0d4\"}.di-city-pass::before,.di-E0D5::before{content:\"\\e0d5\"}.di-california::before,.di-E0D6::before{content:\"\\e0d6\"}.di-southern-california::before,.di-E0D7::before{content:\"\\e0d7\"}.di-etickets::before,.di-E0D8::before{content:\"\\e0d8\"}.di-compare-offers::before,.di-E0D9::before{content:\"\\e0d9\"}.di-baja-california-resident::before,.di-E0DA::before{content:\"\\e0da\"}.di-area-attractions::before,.di-E0DB::before{content:\"\\e0db\"}.di-anaheim-resort-transit::before,.di-E0DC::before{content:\"\\e0dc\"}.di-edit-fastpass::before,.di-E0DD::before{content:\"\\e0dd\"}.di-in-park-merchandise::before,.di-E0E0::before{content:\"\\e0e0\"}.di-travel-insurance::before,.di-E0E1::before{content:\"\\e0e1\"}.di-texas-resident::before,.di-E0E2::before{content:\"\\e0e2\"}.di-canadian-resident::before,.di-E0E3::before{content:\"\\e0e3\"}.di-add-tickets::before,.di-E0E4::before{content:\"\\e0e4\"}.di-splurge::before,.di-E0E5::before{content:\"\\e0e5\"}.di-disneyland-annual-passes::before,.di-E0E6::before{content:\"\\e0e6\"}.di-dlr-tickets-passes::before,.di-E0E7::before{content:\"\\e0e7\"}.di-get-vacation-offer-recommended::before,.di-E0E8::before{content:\"\\e0e8\"}.di-get-vacation-offer-guest-created::before,.di-E0E9::before{content:\"\\e0e9\"}.di-shdr-fastpass::before,.di-E0EA::before{content:\"\\e0ea\"}.di-currency-convertor::before,.di-E0EB::before{content:\"\\e0eb\"}.di-call-to-buy-tickets::before,.di-E0EC::before{content:\"\\e0ec\"}.di-wdw-tickets-and-passes::before,.di-E0ED::before{content:\"\\e0ed\"}.di-renew-annual-pass::before,.di-E0EE::before{content:\"\\e0ee\"}.di-renew-annual-pass-dlr::before,.di-E0EF::before{content:\"\\e0ef\"}.di-annual-pass-wdw::before,.di-E0F0::before{content:\"\\e0f0\"}.di-mobile-order::before,.di-E0F1::before{content:\"\\e0f1\"}.di-fastpass::before,.di-E0F2::before{content:\"\\e0f2\"}.di-ticket-ap-upgrade::before,.di-E0F3::before{content:\"\\e0f3\"}.di-shdr-premium-access::before,.di-E0F4::before{content:\"\\e0f4\"}.di-shdr-tickets-and-passes::before,.di-E0F5::before{content:\"\\e0f5\"}.di-shdr-seasonal-pass::before,.di-E0F6::before{content:\"\\e0f6\"}.di-shdr-fastpass-reverse::before,.di-E0F7::before{content:\"\\e0f7\"}.di-disney-maxpass::before,.di-E0F8::before{content:\"\\e0f8\"}.di-shdr-premium-access-chinese::before,.di-E0F9::before{content:\"\\e0f9\"}.di-hawaii-resident::before,.di-E0FA::before{content:\"\\e0fa\"}.di-club-33-membership::before,.di-E0FB::before{content:\"\\e0fb\"}.di-order-grocery-delivery::before,.di-E0FC::before{content:\"\\e0fc\"}.di-special-offers::before,.di-E0FD::before{content:\"\\e0fd\"}.di-prebook-fastpass::before,.di-E0FE::before{content:\"\\e0fe\"}.di-upgrade-offer::before,.di-E0FF::before{content:\"\\e0ff\"}.di-mdx::before,.di-E100::before{content:\"\\e100\"}.di-about-me::before,.di-E101::before{content:\"\\e101\"}.di-friends-family::before,.di-E102::before{content:\"\\e102\"}.di-account-settings::before,.di-E103::before{content:\"\\e103\"}.di-magicbands-v2::before,.di-E104::before{content:\"\\e104\"}.di-magic-cards::before,.di-E105::before{content:\"\\e105\"}.di-pin-payment-methods::before,.di-E106::before{content:\"\\e106\"}.di-communication-references::before,.di-E107::before{content:\"\\e107\"}.di-wishlist::before,.di-E108::before{content:\"\\e108\"}.di-link-existing-reservation::before,.di-E109::before{content:\"\\e109\"}.di-guest-entered-schedule-item::before,.di-E10A::before{content:\"\\e10a\"}.di-birthday::before,.di-E10B::before{content:\"\\e10b\"}.di-memory-maker::before,.di-E10C::before{content:\"\\e10c\"}.di-memory-maker-2::before,.di-E10D::before{content:\"\\e10d\"}.di-passes-and-memberships::before,.di-E10E::before{content:\"\\e10e\"}.di-link-mdx-tickets-passes::before,.di-E10F::before{content:\"\\e10f\"}.di-link-mdx-resort-reservations::before,.di-E110::before{content:\"\\e110\"}.di-link-mdx-dining-reservations::before,.di-E111::before{content:\"\\e111\"}.di-link-dlr-tickets::before,.di-E112::before{content:\"\\e112\"}.di-link-main-entrance::before,.di-E113::before{content:\"\\e113\"}.di-digital-key::before,.di-E115::before{content:\"\\e115\"}.di-wishlist-item-added::before,.di-E116::before{content:\"\\e116\"}.di-wishlist-empty::before,.di-E117::before{content:\"\\e117\"}.di-magicbands-original::before,.di-E118::before{content:\"\\e118\"}.di-all-activities::before,.di-E140::before{content:\"\\e140\"}.di-attractions::before,.di-E141::before{content:\"\\e141\"}.di-characters::before,.di-E142::before{content:\"\\e142\"}.di-entertainment::before,.di-E143::before{content:\"\\e143\"}.di-tours-events::before,.di-E144::before{content:\"\\e144\"}.di-in-park-shopping::before,.di-E145::before{content:\"\\e145\"}.di-spas::before,.di-E146::before{content:\"\\e146\"}.di-tour::before,.di-E14C::before{content:\"\\e14c\"}.di-spring-break::before,.di-E14D::before{content:\"\\e14d\"}.di-fireworks::before,.di-E14E::before{content:\"\\e14e\"}.di-shows::before,.di-E14F::before{content:\"\\e14f\"}.di-dining::before,.di-E180::before{content:\"\\e180\"}.di-dining-plan::before,.di-E181::before{content:\"\\e181\"}.di-dining-plan-accepted::before,.di-E182::before{content:\"\\e182\"}.di-dining-plan-not-accepted::before,.di-E183::before{content:\"\\e183\"}.di-dining-reservation::before,.di-E184::before{content:\"\\e184\"}.di-menu::before,.di-E185::before{content:\"\\e185\"}.di-prix-fixe-qsr::before,.di-E186::before{content:\"\\e186\"}.di-prix-fixe-tsr::before,.di-E187::before{content:\"\\e187\"}.di-entrees-qsr::before,.di-E188::before{content:\"\\e188\"}.di-entrees-tsr::before,.di-E189::before{content:\"\\e189\"}.di-beverages::before,.di-E18A::before{content:\"\\e18a\"}.di-wine::before,.di-E18B::before{content:\"\\e18b\"}.di-beer::before,.di-E18C::before{content:\"\\e18c\"}.di-cocktails::before,.di-E18D::before{content:\"\\e18d\"}.di-appetizers::before,.di-E18E::before{content:\"\\e18e\"}.di-sandwiches::before,.di-E18F::before{content:\"\\e18f\"}.di-beef-pork-chicken::before,.di-E190::before{content:\"\\e190\"}.di-seafood::before,.di-E191::before{content:\"\\e191\"}.di-pasta::before,.di-E192::before{content:\"\\e192\"}.di-salads::before,.di-E193::before{content:\"\\e193\"}.di-sides::before,.di-E194::before{content:\"\\e194\"}.di-desserts::before,.di-E195::before{content:\"\\e195\"}.di-buffet::before,.di-E196::before{content:\"\\e196\"}.di-favorites::before,.di-E197::before{content:\"\\e197\"}.di-kids-picks::before,.di-E198::before{content:\"\\e198\"}.di-featured-items::before,.di-E199::before{content:\"\\e199\"}.di-nutritional-content::before,.di-E19A::before{content:\"\\e19a\"}.di-nutritional-information::before,.di-E19B::before{content:\"\\e19b\"}.di-gluten-free::before,.di-E19C::before{content:\"\\e19c\"}.di-dairy-free::before,.di-E19D::before{content:\"\\e19d\"}.di-character-dining::before,.di-E19E::before{content:\"\\e19e\"}.di-mockey-food-seal::before,.di-E19F::before{content:\"\\e19f\"}.di-priority-seating::before,.di-E1A1::before{content:\"\\e1a1\"}.di-vegetarian::before,.di-E1A2::before{content:\"\\e1a2\"}.di-raw-food::before,.di-E1A3::before{content:\"\\e1a3\"}.di-guest-favorite-food::before,.di-E1A4::before{content:\"\\e1a4\"}.di-mobile-order-food::before,.di-E1A5::before{content:\"\\e1a5\"}.di-adult-table-service::before,.di-E1A6::before{content:\"\\e1a6\"}.di-celebration-cakes::before,.di-E1A7::before{content:\"\\e1a7\"}.di-disney-dining-plan::before,.di-E1A8::before{content:\"\\e1a8\"}.di-disney-deluxe-dining-plan::before,.di-E1A9::before{content:\"\\e1a9\"}.di-coffee-mug::before,.di-E1AA::before{content:\"\\e1aa\"}.di-mobile-order-food::before,.di-E1AB::before{content:\"\\e1ab\"}.di-qs-dining-card::before,.di-E1AC::before{content:\"\\e1ac\"}.di-allergy-friendly::before,.di-E1AD::before{content:\"\\e1ad\"}.di-kids-meals::before,.di-E1AE::before{content:\"\\e1ae\"}.di-dining-check-in::before,.di-E1AF::before{content:\"\\e1af\"}.di-sports-recreation::before,.di-E1C0::before{content:\"\\e1c0\"}.di-campfire::before,.di-E1C1::before{content:\"\\e1c1\"}.di-snorkeling::before,.di-E1C2::before{content:\"\\e1c2\"}.di-swimming::before,.di-E1C3::before{content:\"\\e1c3\"}.di-boating::before,.di-E1C4::before{content:\"\\e1c4\"}.di-running::before,.di-E1C5::before{content:\"\\e1c5\"}.di-fitness-room::before,.di-E1C6::before{content:\"\\e1c6\"}.di-game::before,.di-E1C7::before{content:\"\\e1c7\"}.di-shuffleboard::before,.di-E1C8::before{content:\"\\e1c8\"}.di-parasailing::before,.di-E1C9::before{content:\"\\e1c9\"}.di-playground::before,.di-E1CA::before{content:\"\\e1ca\"}.di-horseback-riding::before,.di-E1CB::before{content:\"\\e1cb\"}.di-pool-tables::before,.di-E1CC::before{content:\"\\e1cc\"}.di-fishing::before,.di-E1CD::before{content:\"\\e1cd\"}.di-volleyball::before,.di-E1CE::before{content:\"\\e1ce\"}.di-basketball::before,.di-E1CF::before{content:\"\\e1cf\"}.di-cycling::before,.di-E1D0::before{content:\"\\e1d0\"}.di-explore::before,.di-E1D1::before{content:\"\\e1d1\"}.di-disneyland-recreation::before,.di-E1D2::before{content:\"\\e1d2\"}.di-baseball::before,.di-E1D4::before{content:\"\\e1d4\"}.di-field-hockey::before,.di-E1D5::before{content:\"\\e1d5\"}.di-football::before,.di-E1D6::before{content:\"\\e1d6\"}.di-gymnastics::before,.di-E1D7::before{content:\"\\e1d7\"}.di-lacrosse::before,.di-E1D8::before{content:\"\\e1d8\"}.di-crosscountry::before,.di-E1D9::before{content:\"\\e1d9\"}.di-soccer::before,.di-E1DA::before{content:\"\\e1da\"}.di-softball-fastpitch::before,.di-E1DB::before{content:\"\\e1db\"}.di-softball-slowpitch::before,.di-E1DC::before{content:\"\\e1dc\"}.di-track-field::before,.di-E1DD::before{content:\"\\e1dd\"}.di-tennis-court::before,.di-E1DE::before{content:\"\\e1de\"}.di-generic-sports::before,.di-E1DF::before{content:\"\\e1df\"}.di-maps::before,.di-E200::before{content:\"\\e200\"}.di-guest-services::before,.di-E201::before{content:\"\\e201\"}.di-concierge::before,.di-E202::before{content:\"\\e202\"}.di-resort-checkin::before,.di-E203::before{content:\"\\e203\"}.di-celebration::before,.di-E204::before{content:\"\\e204\"}.di-aeds::before,.di-E205::before{content:\"\\e205\"}.di-smoking-area::before,.di-E206::before{content:\"\\e206\"}.di-no-smoking::before,.di-E207::before{content:\"\\e207\"}.di-lost-found::before,.di-E208::before{content:\"\\e208\"}.di-baby-care-center::before,.di-E209::before{content:\"\\e209\"}.di-currency-exchange::before,.di-E20A::before{content:\"\\e20a\"}.di-atm::before,.di-E20B::before{content:\"\\e20b\"}.di-restrooms::before,.di-E20C::before{content:\"\\e20c\"}.di-first-aid::before,.di-E20D::before{content:\"\\e20d\"}.di-laundry::before,.di-E20E::before{content:\"\\e20e\"}.di-valet::before,.di-E20F::before{content:\"\\e20f\"}.di-in-room-babysitting::before,.di-E210::before{content:\"\\e210\"}.di-business-center::before,.di-E211::before{content:\"\\e211\"}.di-cabanas::before,.di-E212::before{content:\"\\e212\"}.di-ecv::before,.di-E213::before{content:\"\\e213\"}.di-strollers::before,.di-E214::before{content:\"\\e214\"}.di-parking-lot::before,.di-E215::before{content:\"\\e215\"}.di-kennel::before,.di-E216::before{content:\"\\e216\"}.di-package-pick-up::before,.di-E217::before{content:\"\\e217\"}.di-gas-station::before,.di-E218::before{content:\"\\e218\"}.di-pin-trading::before,.di-E219::before{content:\"\\e219\"}.di-translation-devices::before,.di-E21A::before{content:\"\\e21a\"}.di-wedding-ceremonies::before,.di-E21B::before{content:\"\\e21b\"}.di-resort-amenities::before,.di-E21C::before{content:\"\\e21c\"}.di-movies-under-the-stars::before,.di-E21D::before{content:\"\\e21d\"}.di-kodak-picture-spot::before,.di-E21E::before{content:\"\\e21e\"}.di-locker-rentals::before,.di-E21F::before{content:\"\\e21f\"}.di-here-now::before,.di-E220::before{content:\"\\e220\"}.di-current-location::before,.di-E221::before{content:\"\\e221\"}.di-supervise-children::before,.di-E222::before{content:\"\\e222\"}.di-rider-swap::before,.di-E223::before{content:\"\\e223\"}.di-service-dog::before,.di-E224::before{content:\"\\e224\"}.di-free-disney-wifi::before,.di-E225::before{content:\"\\e225\"}.di-generic-wifi::before,.di-E226::before{content:\"\\e226\"}.di-location-pin::before,.di-E22B::before{content:\"\\e22b\"}.di-disney-express-luggage::before,.di-E22D::before{content:\"\\e22d\"}.di-picnic-area::before,.di-E230::before{content:\"\\e230\"}.di-nikon-picture-spot::before,.di-E236::before{content:\"\\e236\"}.di-atm-2::before,.di-E237::before{content:\"\\e237\"}.di-drinking-fountains::before,.di-E238::before{content:\"\\e238\"}.di-package-express::before,.di-E239::before{content:\"\\e239\"}.di-kingdom-club-bellman::before,.di-E23A::before{content:\"\\e23a\"}.di-in-park-info::before,.di-E23B::before{content:\"\\e23b\"}.di-magical-coin-press-machine::before,.di-E23C::before{content:\"\\e23c\"}.di-stroller-parking::before,.di-E23D::before{content:\"\\e23d\"}.di-electric-car-charging-station::before,.di-E23E::before{content:\"\\e23e\"}.di-parade-route-show-area::before,.di-E23F::before{content:\"\\e23f\"}.di-alert::before,.di-E240::before{content:\"\\e240\"}.di-checkmark::before,.di-E241::before{content:\"\\e241\"}.di-faqs::before,.di-E242::before{content:\"\\e242\"}.di-quick-answer::before,.di-E243::before{content:\"\\e243\"}.di-disney-parks-blog::before,.di-E244::before{content:\"\\e244\"}.di-sms::before,.di-E245::before{content:\"\\e245\"}.di-press-center::before,.di-E246::before{content:\"\\e246\"}.di-moms-panel::before,.di-E247::before{content:\"\\e247\"}.di-park-schedule::before,.di-E248::before{content:\"\\e248\"}.di-time::before,.di-E249::before{content:\"\\e249\"}.di-privacy-policies::before,.di-E24A::before{content:\"\\e24a\"}.di-terms-conditions::before,.di-E24B::before{content:\"\\e24b\"}.di-accessibility::before,.di-E24C::before{content:\"\\e24c\"}.di-pre-arrival-tips::before,.di-E24D::before{content:\"\\e24d\"}.di-reservations::before,.di-E24E::before{content:\"\\e24e\"}.di-registration::before,.di-E24F::before{content:\"\\e24f\"}.di-help-support::before,.di-E250::before{content:\"\\e250\"}.di-learn-more::before,.di-E251::before{content:\"\\e251\"}.di-email::before,.di-E252::before{content:\"\\e252\"}.di-chat::before,.di-E253::before{content:\"\\e253\"}.di-call::before,.di-E254::before{content:\"\\e254\"}.di-14-days-notice::before,.di-E255::before{content:\"\\e255\"}.di-6-months-notice::before,.di-E256::before{content:\"\\e256\"}.di-blackout-days::before,.di-E257::before{content:\"\\e257\"}.di-3-days-notice::before,.di-E258::before{content:\"\\e258\"}.di-website-support::before,.di-E259::before{content:\"\\e259\"}.di-restriction::before,.di-E25A::before{content:\"\\e25a\"}.di-recommendation::before,.di-E25B::before{content:\"\\e25b\"}.di-na-dash::before,.di-E25C::before{content:\"\\e25c\"}.di-magic-morning::before,.di-E25D::before{content:\"\\e25d\"}.di-global-languages::before,.di-E25E::before{content:\"\\e25e\"}.di-good-neighbor-hotel::before,.di-E25F::before{content:\"\\e25f\"}.di-travel-information::before,.di-E261::before{content:\"\\e261\"}.di-visiting-with-groups::before,.di-E262::before{content:\"\\e262\"}.di-visiting-with-children::before,.di-E263::before{content:\"\\e263\"}.di-disney-like-light::before,.di-E266::before{content:\"\\e266\"}.di-disney-like-dark::before,.di-E267::before{content:\"\\e267\"}.di-written-aids::before,.di-E268::before{content:\"\\e268\"}.di-generations-travel::before,.di-E269::before{content:\"\\e269\"}.di-empty-chat::before,.di-E26A::before{content:\"\\e26a\"}.di-filled-chat::before,.di-E26B::before{content:\"\\e26b\"}.di-empty-checkbox::before,.di-E26C::before{content:\"\\e26c\"}.di-selected-solid-checkbox::before,.di-E26D::before{content:\"\\e26d\"}.di-selected-disabled::before,.di-E26E::before{content:\"\\e26e\"}.di-indeterminate::before,.di-E26F::before{content:\"\\e26f\"}.di-10-days-notice::before,.di-E270::before{content:\"\\e270\"}.di-wdw-ap-blockout-cal::before,.di-E271::before{content:\"\\e271\"}.di-flexible-ticket::before,.di-E272::before{content:\"\\e272\"}.di-ride-height::before,.di-E275::before{content:\"\\e275\"}.di-adults::before,.di-E276::before{content:\"\\e276\"}.di-teens-tweens::before,.di-E277::before{content:\"\\e277\"}.di-kids::before,.di-E278::before{content:\"\\e278\"}.di-price-range::before,.di-E279::before{content:\"\\e279\"}.di-price-range-outlined::before,.di-E27A::before{content:\"\\e27a\"}.di-time-outlined::before,.di-E27B::before{content:\"\\e27b\"}.di-all-parks-available::before,.di-E27C::before{content:\"\\e27c\"}.di-some-parks-available::before,.di-E27D::before{content:\"\\e27d\"}.di-my-media::before,.di-E280::before{content:\"\\e280\"}.di-images::before,.di-E281::before{content:\"\\e281\"}.di-videos::before,.di-E282::before{content:\"\\e282\"}.di-photo-pass::before,.di-E283::before{content:\"\\e283\"}.di-photo-pass-plus::before,.di-E284::before{content:\"\\e284\"}.di-media-favorites::before,.di-E285::before{content:\"\\e285\"}.di-photo-fun::before,.di-E286::before{content:\"\\e286\"}.di-disney-vision::before,.di-E287::before{content:\"\\e287\"}.di-dvd-cd::before,.di-E288::before{content:\"\\e288\"}.di-shdr-photopass::before,.di-E289::before{content:\"\\e289\"}.di-order-dvd::before,.di-E28B::before{content:\"\\e28b\"}.di-presented-in-3d::before,.di-E28C::before{content:\"\\e28c\"}.di-guest-photos::before,.di-E28D::before{content:\"\\e28d\"}.di-on-demand::before,.di-E28E::before{content:\"\\e28e\"}.di-live-stream::before,.di-E28F::before{content:\"\\e28f\"}.di-photopass-lenses::before,.di-E290::before{content:\"\\e290\"}.di-monorail::before,.di-E2C0::before{content:\"\\e2c0\"}.di-bus::before,.di-E2C1::before{content:\"\\e2c1\"}.di-car::before,.di-E2C2::before{content:\"\\e2c2\"}.di-boat::before,.di-E2C3::before{content:\"\\e2c3\"}.di-taxi::before,.di-E2C4::before{content:\"\\e2c4\"}.di-flight::before,.di-E2C5::before{content:\"\\e2c5\"}.di-return-flight::before,.di-E2C6::before{content:\"\\e2c6\"}.di-walking::before,.di-E2C7::before{content:\"\\e2c7\"}.di-free-shuttle::before,.di-E2C8::before{content:\"\\e2c8\"}.di-hkdl-mtr-disney-resort-line::before,.di-E2CE::before{content:\"\\e2ce\"}.di-bus-schedule::before,.di-E2CF::before{content:\"\\e2cf\"}.di-minnie-vans-ride-share::before,.di-E2D0::before{content:\"\\e2d0\"}.di-transportation-multiple::before,.di-E2D1::before{content:\"\\e2d1\"}.di-wdw-skylinero::before,.di-E2D2::before{content:\"\\e2d2\"}.di-close-button::before,.di-E300::before{content:\"\\e300\"}.di-add-button::before,.di-E301::before{content:\"\\e301\"}.di-information::before,.di-E302::before{content:\"\\e302\"}.di-share::before,.di-E303::before{content:\"\\e303\"}.di-download::before,.di-E304::before{content:\"\\e304\"}.di-show-filters::before,.di-E305::before{content:\"\\e305\"}.di-hide-filters::before,.di-E306::before{content:\"\\e306\"}.di-3d-spin::before,.di-E307::before{content:\"\\e307\"}.di-media-play-button::before,.di-E308::before{content:\"\\e308\"}.di-media-pause-button::before,.di-E309::before{content:\"\\e309\"}.di-pdf::before,.di-E30A::before{content:\"\\e30a\"}.di-duplicate-offer::before,.di-E30B::before{content:\"\\e30b\"}.di-next::before,.di-E30C::before{content:\"\\e30c\"}.di-previous::before,.di-E30D::before{content:\"\\e30d\"}.di-print::before,.di-E30F::before{content:\"\\e30f\"}.di-search::before,.di-E310::before{content:\"\\e310\"}.di-calendar-month::before,.di-E311::before{content:\"\\e311\"}.di-calendar-day-view::before,.di-E312::before{content:\"\\e312\"}.di-more::before,.di-E313::before{content:\"\\e313\"}.di-menu-global-nav::before,.di-E314::before{content:\"\\e314\"}.di-menus-button::before,.di-E315::before{content:\"\\e315\"}.di-norgie-opened::before,.di-E316::before{content:\"\\e316\"}.di-upload::before,.di-E317::before{content:\"\\e317\"}.di-lists::before,.di-E318::before{content:\"\\e318\"}.di-filter::before,.di-E319::before{content:\"\\e319\"}.di-scan-barcode::before,.di-E31A::before{content:\"\\e31a\"}.di-keyboard-entry::before,.di-E31B::before{content:\"\\e31b\"}.di-download-mobile-app::before,.di-E31C::before{content:\"\\e31c\"}.di-view-gallery::before,.di-E31D::before{content:\"\\e31d\"}.di-see-info-page-button::before,.di-E31E::before{content:\"\\e31e\"}.di-media-gallery-photo-button::before,.di-E31F::before{content:\"\\e31f\"}.di-media-gallery-video-button::before,.di-E320::before{content:\"\\e320\"}.di-refresh::before,.di-E321::before{content:\"\\e321\"}.di-compose-message::before,.di-E322::before{content:\"\\e322\"}.di-add-contact::before,.di-E323::before{content:\"\\e323\"}.di-contact-list::before,.di-E324::before{content:\"\\e324\"}.di-norgie-up::before,.di-E325::before{content:\"\\e325\"}.di-norgie-left::before,.di-E326::before{content:\"\\e326\"}.di-mobile-app::before,.di-E327::before{content:\"\\e327\"}.di-home::before,.di-E328::before{content:\"\\e328\"}.di-return-arrow::before,.di-E329::before{content:\"\\e329\"}.di-share-2::before,.di-E32A::before{content:\"\\e32a\"}.di-delete-button::before,.di-E32B::before{content:\"\\e32b\"}.di-fast-forward-button::before,.di-E32C::before{content:\"\\e32c\"}.di-rewind-button::before,.di-E32D::before{content:\"\\e32d\"}.di-pulldown::before,.di-E32E::before{content:\"\\e32e\"}.di-increase-button::before,.di-E32F::before{content:\"\\e32f\"}.di-decrease-button::before,.di-E330::before{content:\"\\e330\"}.di-flip-turn-over::before,.di-E331::before{content:\"\\e331\"}.di-previous-2::before,.di-E332::before{content:\"\\e332\"}.di-next-2::before,.di-E333::before{content:\"\\e333\"}.di-arrow-back::before,.di-E334::before{content:\"\\e334\"}.di-arrow-up::before,.di-E335::before{content:\"\\e335\"}.di-arrow-down::before,.di-E336::before{content:\"\\e336\"}.di-expand-gallery::before,.di-E337::before{content:\"\\e337\"}.di-360-video::before,.di-E338::before{content:\"\\e338\"}.di-volume-control::before,.di-E339::before{content:\"\\e339\"}.di-app-card-info::before,.di-E33A::before{content:\"\\e33a\"}.di-app-card-flip::before,.di-E33B::before{content:\"\\e33b\"}.di-close-reversed::before,.di-E33E::before{content:\"\\e33e\"}.di-expand-show-more::before,.di-E33F::before{content:\"\\e33f\"}.di-wheelchair-accessibility::before,.di-E340::before{content:\"\\e340\"}.di-transfer-from-wheelchair::before,.di-E341::before{content:\"\\e341\"}.di-transfer-to-wheelchair::before,.di-E342::before{content:\"\\e342\"}.di-transfer-to-wheelchair-then-ride::before,.di-E343::before{content:\"\\e343\"}.di-ambulatory::before,.di-E344::before{content:\"\\e344\"}.di-visual-impairment::before,.di-E345::before{content:\"\\e345\"}.di-hearing-impairment::before,.di-E346::before{content:\"\\e346\"}.di-sign-language::before,.di-E347::before{content:\"\\e347\"}.di-audio-description::before,.di-E348::before{content:\"\\e348\"}.di-handheld-captioning::before,.di-E349::before{content:\"\\e349\"}.di-reflective-captioning::before,.di-E34A::before{content:\"\\e34a\"}.di-closed-captioning::before,.di-E34B::before{content:\"\\e34b\"}.di-physicial-consideration-red-yellow::before,.di-E34C::before{content:\"\\e34c\"}.di-scary-consideration-yellow::before,.di-E34D::before{content:\"\\e34d\"}.di-dlp-mobility-disabilities::before,.di-E34E::before{content:\"\\e34e\"}.di-dlp-hearing-disabilities::before,.di-E34F::before{content:\"\\e34f\"}.di-dlp-visual-disabilities::before,.di-E350::before{content:\"\\e350\"}.di-photosensitive-epilepsy::before,.di-E351::before{content:\"\\e351\"}.di-dlp-mental-cognitive-disabilities::before,.di-E352::before{content:\"\\e352\"}.di-suitable-for-amputees::before,.di-E353::before{content:\"\\e353\"}.di-suitable-for-difficulty-standing::before,.di-E354::before{content:\"\\e354\"}.di-capable-of-climbing-steps::before,.di-E355::before{content:\"\\e355\"}.di-disabilities-services::before,.di-E356::before{content:\"\\e356\"}.di-disabilities-guide-book::before,.di-E357::before{content:\"\\e357\"}.di-wheelchair-rental::before,.di-E358::before{content:\"\\e358\"}.di-disabilities-designated-viewing::before,.di-E359::before{content:\"\\e359\"}.di-may-remain-in-wheelchair::before,.di-E35A::before{content:\"\\e35a\"}.di-must-be-ambulatory-2::before,.di-E35B::before{content:\"\\e35b\"}.di-suitable-for-blind::before,.di-E35C::before{content:\"\\e35c\"}.di-suitable-for-autism::before,.di-E35D::before{content:\"\\e35d\"}.di-sign-language-2::before,.di-E35E::before{content:\"\\e35e\"}.di-tactile-maps::before,.di-E35F::before{content:\"\\e35f\"}.di-braille-guide-books::before,.di-E360::before{content:\"\\e360\"}.di-suitable-for-learning-disabilities::before,.di-E361::before{content:\"\\e361\"}.di-induction-loop::before,.di-E362::before{content:\"\\e362\"}.di-dimly-lit-space::before,.di-E363::before{content:\"\\e363\"}.di-light-rain-indoors::before,.di-E364::before{content:\"\\e364\"}.di-show-contains-bubble::before,.di-E365::before{content:\"\\e365\"}.di-hdd-illness::before,.di-E366::before{content:\"\\e366\"}.di-open-captioning::before,.di-E367::before{content:\"\\e367\"}.di-magnetic-fields::before,.di-E368::before{content:\"\\e368\"}.di-open-captioning-square::before,.di-E369::before{content:\"\\e369\"}.di-gifts::before,.di-E380::before{content:\"\\e380\"}.di-character-calls::before,.di-E381::before{content:\"\\e381\"}.di-performing-arts::before,.di-E382::before{content:\"\\e382\"}.di-education::before,.di-E383::before{content:\"\\e383\"}.di-lock::before,.di-E384::before{content:\"\\e384\"}.di-facebook::before,.di-E385::before{content:\"\\e385\"}.di-twitter::before,.di-E386::before{content:\"\\e386\"}.di-youtube::before,.di-E387::before{content:\"\\e387\"}.di-instagram::before,.di-E388::before{content:\"\\e388\"}.di-pinterest::before,.di-E389::before{content:\"\\e389\"}.di-google-plus::before,.di-E38A::before{content:\"\\e38a\"}.di-disney-cast::before,.di-E38B::before{content:\"\\e38b\"}.di-disney-response::before,.di-E38C::before{content:\"\\e38c\"}.di-thrill-seekers::before,.di-E38E::before{content:\"\\e38e\"}.di-doll::before,.di-E390::before{content:\"\\e390\"}.di-front-desk::before,.di-E391::before{content:\"\\e391\"}.di-movies::before,.di-E392::before{content:\"\\e392\"}.di-unlocked::before,.di-E393::before{content:\"\\e393\"}.di-tumblr::before,.di-E394::before{content:\"\\e394\"}.di-services::before,.di-E395::before{content:\"\\e395\"}.di-old-photopass-plus::before,.di-E396::before{content:\"\\e396\"}.di-hkdl-sina-weibo-social::before,.di-E397::before{content:\"\\e397\"}.di-hkdl-baidu-tieba-social::before,.di-E398::before{content:\"\\e398\"}.di-hkdl-webchat-social::before,.di-E399::before{content:\"\\e399\"}.di-disney-wild-about-safety::before,.di-E39A::before{content:\"\\e39a\"}.di-romantic-celebration::before,.di-E39B::before{content:\"\\e39b\"}.di-facebook-icon-alone::before,.di-E39C::before{content:\"\\e39c\"}.di-twitter-icon-alone::before,.di-E39D::before{content:\"\\e39d\"}.di-snapchat::before,.di-E39E::before{content:\"\\e39e\"}.di-photopass-attraction-id::before,.di-E39F::before{content:\"\\e39f\"}.di-achievement::before,.di-E3A0::before{content:\"\\e3a0\"}.di-apple-music::before,.di-E3A1::before{content:\"\\e3a1\"}.di-apple-music-alternate::before,.di-E3A2::before{content:\"\\e3a2\"}.di-watches-time::before,.di-E3A3::before{content:\"\\e3a3\"}.di-magic-coming-soon::before,.di-E3A4::before{content:\"\\e3a4\"}.di-winter::before,.di-E3E4::before{content:\"\\e3e4\"}.di-spring::before,.di-E3E5::before{content:\"\\e3e5\"}.di-summer::before,.di-E3E6::before{content:\"\\e3e6\"}.di-autumn::before,.di-E3E7::before{content:\"\\e3e7\"}.di-pack-for-weather::before,.di-E3E8::before{content:\"\\e3e8\"}.di-single-rider::before,.di-E440::before{content:\"\\e440\"}.di-atm-china::before,.di-E441::before{content:\"\\e441\"}.di-wayfinding-slight-left::before,.di-E442::before{content:\"\\e442\"}.di-wayfinding-slight-right::before,.di-E443::before{content:\"\\e443\"}.di-wayfinding-turn-left::before,.di-E444::before{content:\"\\e444\"}.di-wayfinding-turn-right::before,.di-E445::before{content:\"\\e445\"}.di-wayfinding-hard-left::before,.di-E446::before{content:\"\\e446\"}.di-wayfinding-hard-right::before,.di-E447::before{content:\"\\e447\"}.di-wayfinding-left::before,.di-E448::before{content:\"\\e448\"}.di-wayfinding-right::before,.di-E449::before{content:\"\\e449\"}.di-wayfinding-forward::before,.di-E44A::before{content:\"\\e44a\"}.di-wayfinding-back::before,.di-E44B::before{content:\"\\e44b\"}.di-wayfinding-forward-back::before,.di-E44C::before{content:\"\\e44c\"}.di-wayfinding-right-left::before,.di-E44D::before{content:\"\\e44d\"}.di-wayfinding-around-slight-left::before,.di-E44E::before{content:\"\\e44e\"}.di-wayfinding-around-slight-right::before,.di-E44F::before{content:\"\\e44f\"}.di-wayfinding-around-turn-left::before,.di-E450::before{content:\"\\e450\"}.di-wayfinding-around-turn-right::before,.di-E451::before{content:\"\\e451\"}.di-wayfinding-around-hard-left::before,.di-E452::before{content:\"\\e452\"}.di-wayfinding-around-hard-right::before,.di-E453::before{content:\"\\e453\"}.di-wayfinding-around-left::before,.di-E454::before{content:\"\\e454\"}.di-wayfinding-around-right::before,.di-E455::before{content:\"\\e455\"}.di-wayfinding-around-forward-left::before,.di-E456::before{content:\"\\e456\"}.di-wayfinding-around-forward-right::before,.di-E457::before{content:\"\\e457\"}.di-wayfinding-u-turn-right::before,.di-E458::before{content:\"\\e458\"}.di-wayfinding-u-turn-left::before,.di-E459::before{content:\"\\e459\"}.di-wayfinding-ramp-left::before,.di-E45A::before{content:\"\\e45a\"}.di-wayfinding-ramp-right::before,.di-E45B::before{content:\"\\e45b\"}.di-wayfinding-fork-left::before,.di-E45C::before{content:\"\\e45c\"}.di-wayfinding-fork-right::before,.di-E45D::before{content:\"\\e45d\"}.di-wayfinding-around-about-left::before,.di-E45E::before{content:\"\\e45e\"}.di-wayfinding-around-about-right::before,.di-E45F::before{content:\"\\e45f\"}.di-wayfinding-merge::before,.di-E460::before{content:\"\\e460\"}.di-cribs-and-playpens::before,.di-E461::before{content:\"\\e461\"}.di-baby-care-center2::before,.di-E462::before{content:\"\\e462\"}.di-epi-pen::before,.di-E463::before{content:\"\\e463\"}.di-mobile-charging-station::before,.di-E464::before{content:\"\\e464\"}.di-security-info::before,.di-E465::before{content:\"\\e465\"}.di-refrigerator-available::before,.di-E466::before{content:\"\\e466\"}.di-repellant-zika::before,.di-E467::before{content:\"\\e467\"}.di-hurricane-information::before,.di-E468::before{content:\"\\e468\"}.di-recenter-map::before,.di-E46A::before{content:\"\\e46a\"}.di-location-pin::before,.di-E46C::before{content:\"\\e46c\"}.di-transportation-parking-info::before,.di-E46D::before{content:\"\\e46d\"}.di-resort-automatic-check-out::before,.di-E46E::before{content:\"\\e46e\"}.di-service-your-way::before,.di-E46F::before{content:\"\\e46f\"}.di-direct-to-room::before,.di-E470::before{content:\"\\e470\"}.di-premium-service-shdr::before,.di-E471::before{content:\"\\e471\"}.di-virtual-queue::before,.di-E472::before{content:\"\\e472\"}.di-energy-monster::before,.di-E473::before{content:\"\\e473\"}.di-elevators::before,.di-E475::before{content:\"\\e475\"}.di-salon::before,.di-E476::before{content:\"\\e476\"}.di-clothing::before,.di-E480::before{content:\"\\e480\"}.di-accessories::before,.di-E481::before{content:\"\\e481\"}.di-home-office::before,.di-E482::before{content:\"\\e482\"}.di-toys-games::before,.di-E483::before{content:\"\\e483\"}.di-art-collectibles::before,.di-E484::before{content:\"\\e484\"}.di-entertainment::before,.di-E485::before{content:\"\\e485\"}.di-health-beauty::before,.di-E486::before{content:\"\\e486\"}.di-sweets::before,.di-E487::before{content:\"\\e487\"}.di-play-logo::before,.di-E4C0::before{content:\"\\e4c0\"}.di-rocket-race-game::before,.di-E4C1::before{content:\"\\e4c1\"}.di-peter-pan-s-flight-game::before,.di-E4C2::before{content:\"\\e4c2\"}.di-toy-story-mania-game::before,.di-E4C3::before{content:\"\\e4c3\"}.di-trivia-games::before,.di-E4C4::before{content:\"\\e4c4\"}.di-esmeralda-quest::before,.di-E4C5::before{content:\"\\e4c5\"}.di-fortune-red-quest::before,.di-E4C6::before{content:\"\\e4c6\"}.di-temple-of-mara-decoder::before,.di-E4C7::before{content:\"\\e4c7\"}.di-conservation-fund-quest::before,.di-E4C8::before{content:\"\\e4c8\"}.di-soarin-challenge::before,.di-E4C9::before{content:\"\\e4c9\"}.di-agent-p-challenge::before,.di-E4CA::before{content:\"\\e4ca\"}.di-fun-wheel-challenge::before,.di-E4CB::before{content:\"\\e4cb\"}.di-andy-s-game-board-blast::before,.di-E4CC::before{content:\"\\e4cc\"}.di-art-of-animation::before,.di-E4CD::before{content:\"\\e4cd\"}.di-flight-of-passage::before,.di-E4CE::before{content:\"\\e4ce\"}.di-dlr-magic-mural::before,.di-E4CF::before{content:\"\\e4cf\"}.di-splash-mountain::before,.di-E4D0::before{content:\"\\e4d0\"}.di-kidcot-challenge::before,.di-E4D1::before{content:\"\\e4d1\"}.di-swge-millenium-falcon::before,.di-E4D2::before{content:\"\\e4d2\"}.di-swge-star-destroyer::before,.di-E4D3::before{content:\"\\e4d3\"}.di-swge-bso-logo::before,.di-E4D4::before{content:\"\\e4d4\"}.di-add-stepper::before,.di-E500::before{content:\"\\e500\"}.di-reduce-stepper::before,.di-E501::before{content:\"\\e501\"}.di-hide-collapse::before,.di-E502::before{content:\"\\e502\"}.di-mute-volume::before,.di-E503::before{content:\"\\e503\"}.di-unmute-volume::before,.di-E504::before{content:\"\\e504\"}.di-filter-items::before,.di-E505::before{content:\"\\e505\"}.di-forward-thin::before,.di-E506::before{content:\"\\e506\"}.di-back-thin::before,.di-E507::before{content:\"\\e507\"}.di-fast-fwd-thin::before,.di-E508::before{content:\"\\e508\"}.di-rewind-thin::before,.di-E509::before{content:\"\\e509\"}.di-download-thin::before,.di-E50A::before{content:\"\\e50a\"}.di-facial-opt-in-off::before,.di-E50B::before{content:\"\\e50b\"}.di-facial-opt-in-on::before,.di-E50C::before{content:\"\\e50c\"}.di-bluetooth::before,.di-E518::before{content:\"\\e518\"}.di-norgie-closed::before,.di-E534::before{content:\"\\e534\"}.di-fastpass-order-shopping-bag-plus::before,.di-E540::before{content:\"\\e540\"}.di-fastpass-order-shopping-bag::before,.di-E542::before{content:\"\\e542\"}.di-shdr-ticket-annualpass::before,.di-E544::before{content:\"\\e544\"}.di-tickets-outlined::before,.di-E54B::before{content:\"\\e54b\"}.di-early-entry-pass::before,.di-E54C::before{content:\"\\e54c\"}.di-disney-card-member::before,.di-E54D::before{content:\"\\e54d\"}.di-club-33-dlr-member::before,.di-E54E::before{content:\"\\e54e\"}.di-shdr-ap-activation::before,.di-E54F::before{content:\"\\e54f\"}.di-disney-maxpass-alternate::before,.di-E550::before{content:\"\\e550\"}.di-ap-activation::before,.di-E552::before{content:\"\\e552\"}.di-standby-pass::before,.di-E553::before{content:\"\\e553\"}.di-early-park-entry-pass::before,.di-E554::before{content:\"\\e554\"}.di-mobile-checkout::before,.di-E555::before{content:\"\\e555\"}.di-disney-premier-access-global::before,.di-E556::before{content:\"\\e556\"}.di-disney-premier-access-secondary::before,.di-E557::before{content:\"\\e557\"}.di-disney-premier-access-new::before,.di-E558::before{content:\"\\e558\"}.di-golden-oak-resident::before,.di-E559::before{content:\"\\e559\"}.di-disability-access-service::before,.di-E55A::before{content:\"\\e55a\"}.di-lightning-lane::before,.di-E55B::before{content:\"\\e55b\"}.di-disney-plus::before,.di-E55C::before{content:\"\\e55c\"}.di-enchant-key::before,.di-E55D::before{content:\"\\e55d\"}.di-dream-key::before,.di-E55E::before{content:\"\\e55e\"}.di-imagine-key::before,.di-E55F::before{content:\"\\e55f\"}.di-believe-key::before,.di-E560::before{content:\"\\e560\"}.di-unused-character::before,.di-F8FE::before{content:\"\\f8fe\"}wdpr-checkbox{--checkbox-checked-border-color:#1c468e;--checkbox-checked-background-color:#1c468e;--checkbox-unchecked-hover-border-color:#0079bc;--checkbox-checked-hover-border-color:#0079bc;--checkbox-checked-hover-background-color:#0079bc}wdpr-counter{--counter-icon-color:#1c468e;--primary-theme:#1c468e;--secondary-hover:#0079bc;--counter-icon-hover-color:#0079bc}#mobileToggle{--primary-theme:#1c468e}#titleContainer{color:#1c468e}wdpr-checkbox{--checkbox-checked-border-color:#1c468e;--checkbox-checked-background-color:#1c468e;--checkbox-unchecked-hover-border-color:#0079bc;--checkbox-checked-hover-border-color:#0079bc;--checkbox-checked-hover-background-color:#0079bc}.panel-body{--fast-light-blue:#82b0cf;--fast-medium-blue:#0079BC;--fast-dark-blue:#1C468E}.panel.showfast .panel-body{top:16px;position:relative}.panel.showfast .panel-body .qq-rounded-spacer{position:absolute;width:100%;margin-top:-16px;height:16px;border-radius:16px 16px 0px 0px;background-color:#FFF;z-index:100}.panel.showfast .panel-body #purchaseTicketsButton{display:none}.panel.showfast .panel-body h1{display:block;color:var(--fast-dark-blue);font-size:24px;font-style:normal;font-weight:600;line-height:36px;margin:0 31px 24px;text-align:center}.panel.showfast .panel-body wdpr-button .dpo-icon{font-family:\"pepmdx\"}.panel.showfast .panel-body wdpr-button .fast-button{color:var(--fast-medium-blue);margin-left:6px}.panel.showfast .panel-body wdpr-button span.collapsed,.panel.showfast .panel-body wdpr-button span.expanded{right:20px;position:absolute;color:var(--fast-medium-blue)}.panel.showfast .panel-body wdpr-range-datepicker #input-container button i{color:var(--fast-medium-blue)}@media only screen and (min-width: 768px){.panel.showfast .panel-body{border-radius:0px 0px 16px 16px;top:28px}.panel.showfast .panel-body .qq-rounded-spacer{margin-top:-36px;height:28px;left:0px;border-radius:24px 24px 0px 0px}.panel.showfast .panel-body hr,.panel.showfast .panel-body h1{display:none}}@media only screen and (min-width: 1024px){.panel.showfast .panel-body{top:0px}.panel.showfast .panel-body .qq-rounded-spacer{display:none}}.party-mix-select{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;text-align:center;-ms-flex-pack:center;justify-content:center}.party-mix-select .party-selection{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.party-mix-select .party-selection .party-selection-label{text-align:left;margin:0 16px 6px 10px}.party-mix-select .party-selection .party-selection-select{margin:7px}.party-mix-select .party-selection .party-selection-option{font-size:24px;text-align:left;float:none}.party-mix-select .party-selection.party-selection-adult{margin-right:20px}.party-mix-select .party-selection.party-selection-adult,.party-mix-select .party-selection.party-selection-child{display:-ms-inline-flexbox;display:inline-flex;width:50%;color:var(--wdpr-single-select-label-color)}.party-mix-select .party-selection.party-selection-adult .party-selection-option,.party-mix-select .party-selection.party-selection-child .party-selection-option{max-width:100px}.party-mix-select .party-selection.party-selection-adult .party-selection-label,.party-mix-select .party-selection.party-selection-child .party-selection-label{--wdpr-single-select-label-color:#607682;margin-right:16px;display:block;text-align:left;width:100%}.party-mix-select.block{position:relative;display:-ms-flexbox;display:flex}.party-mix-select.block .child-age-container{clear:left;display:inline-block;position:absolute;top:70px;margin-left:33%;width:-webkit-max-content;width:-moz-max-content;width:max-content}.party-mix-select .child-age{padding:15px;background-color:var(--primary-background-theme);border:1px solid var(--primary-disabled);border-radius:0 0 10px 10px}.party-mix-select .child-age .party-selection-select{width:80px}.party-mix-select .child-age::before{content:\"\";position:absolute;height:15px;width:15px;top:-7px;left:50%;margin-left:15px;border-right:1px solid var(--primary-disabled);border-bottom:1px solid var(--primary-disabled);-webkit-transform:rotate(225deg);transform:rotate(225deg);background-color:var(--primary-background-theme)}.party-mix-select .party-selection,.party-mix-select .child-age,.party-mix-select .party-selection-select{display:inline-block}.party-mix-select .control-label{margin-bottom:0px}.party-mix-select .party-selection-label,.party-mix-select .control-label{font-size:12px;color:var(--wdpr-single-select-label-color);margin:0px 16px 10px 6px;display:block}.party-mix-select .warning-message-container{width:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin-top:5px;text-align:left;font-size:14px}.party-mix-select .warning-message-container .alert-icon{color:var(--primary-alert);-ms-flex-item-align:start;align-self:start}.party-mix-select .warning-message-container .warning-message{text-align:left;margin-left:5px}.party-mix-select .max-party-size-exceeded{position:absolute;top:65px;left:-20px;margin:0;padding:10px 20px;width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:650px;background-color:var(--wdpr-lodging-quickquote-background-color, #fff)}.party-mix-select wdpr-counter{--counter-icon-height:24px;--counter-icon-width:24px}.party-mix-select wdpr-single-select{--wdpr-single-select-custom-padding:0px 10px;--wdpr-single-select-hover-custom-padding:0px 10px;--wdpr-single-select-border-width:0px 0px 2px 0px;--wdpr-single-select-active-border-width:0px 0px 2px 0px;--wdpr-single-select-icon-selected-color:var(--cool-grey-700, #5b6c7d);--wdpr-single-select-hover-icon-color:var(--cool-grey-700, #5b6c7d);--wdpr-single-select-border-color:var(--cool-grey-600, #a1afc0)}.party-mix-select wdpr-single-select.has-error{--wdpr-single-select-border-color:var(--primary-alert);--wdpr-single-select-label-color:var(--primary-alert);--wdpr-single-select-hover-border-color:var(--primary-alert);--wdpr-single-select-hover-label-color:var(--primary-alert);--wdpr-single-select-active-border-color:var(--primary-alert);--wdpr-single-select-active-label-color:var(--primary-alert)}.party-mix-select .child-age-label-container{width:100%;padding:0 7px;text-align:left;font-size:12px;font-weight:400;line-height:18px;color:var(--wdpr-single-select-label-color)}.party-mix-select .child-age-selections-container{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%}@media only screen and (max-width: 767.98px){:host{display:block}.party-mix-select{-ms-flex-direction:column;flex-direction:column;text-align:center;-ms-flex-pack:center;justify-content:center}.party-mix-select .party-selection{min-width:150px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:30px}.party-mix-select .party-selection .party-selection-option{font-size:36px;width:35%}.party-mix-select .party-selection.party-selection-adult,.party-mix-select .party-selection.party-selection-child{margin-right:0px;width:auto}.party-mix-select .party-selection.party-selection-adult .party-selection-option,.party-mix-select .party-selection.party-selection-child .party-selection-option{max-width:none}.party-mix-select .party-selection.party-selection-adult .party-selection-label,.party-mix-select .party-selection.party-selection-child .party-selection-label{width:45%}.party-mix-select .party-selection.party-selection-adult .party-selection-label,.party-mix-select .party-selection.party-selection-adult .control-label,.party-mix-select .party-selection.party-selection-child .party-selection-label,.party-mix-select .party-selection.party-selection-child .control-label{font-size:16px;color:var(--wdpr-single-select-label-color);font-weight:600;margin:0px;margin-left:10px;width:45%}.party-mix-select.block .child-age-container{position:relative;width:100%;top:0;padding:0;margin-left:0}.party-mix-select.block .max-party-size-exceeded{position:relative;width:100%;top:0;left:0;padding:0}.party-mix-select .child-age{padding-right:0px;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;width:95%}.party-mix-select .child-age .party-selection-select{-ms-flex:0 0 25%;flex:0 0 25%}.party-mix-select .child-age .party-selection-select .control-label{width:auto}.party-mix-select .child-age .party-selection-select .party-selection-option{width:auto}.party-mix-select .child-age::before{left:80%;margin-left:0px}.party-mix-select wdpr-counter{--counter-icon-height:36px;--counter-icon-width:36px}}@media only screen and (min-width: 768px) and (max-width: 1023px){:host{display:block}.party-mix-select{-ms-flex-direction:column;flex-direction:column;text-align:center;-ms-flex-pack:center;justify-content:center}.party-mix-select .party-selection{min-width:150px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:30px}.party-mix-select .party-selection .party-selection-option{font-size:36px;width:50%}.party-mix-select .party-selection.party-selection-adult,.party-mix-select .party-selection.party-selection-child{margin-right:0px;width:auto}.party-mix-select .party-selection.party-selection-adult .party-selection-option,.party-mix-select .party-selection.party-selection-child .party-selection-option{max-width:none}.party-mix-select .party-selection.party-selection-adult .party-selection-label,.party-mix-select .party-selection.party-selection-child .party-selection-label{width:45%}.party-mix-select .party-selection .party-selection-label,.party-mix-select .party-selection .control-label{font-size:16px;color:var(--wdpr-single-select-label-color);font-weight:600;margin:0px 10px;width:45%}.party-mix-select.block .child-age-container{position:relative;width:100%;top:0;margin-left:0}.party-mix-select.block .max-party-size-exceeded{position:relative;width:100%;top:0}.party-mix-select .child-age{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;width:100%}.party-mix-select .child-age .party-selection-select{width:26%}.party-mix-select .child-age .party-selection-select .control-label{width:auto;font-size:12px}.party-mix-select .child-age .party-selection-select .party-selection-option{width:auto}.party-mix-select .child-age::before{left:73%;margin-left:0px}.party-mix-select wdpr-counter{--counter-icon-height:36px;--counter-icon-width:36px}}";

const WdprPartyMixSelect = /*@__PURE__*/ proxyCustomElement(class WdprPartyMixSelect extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.partyMixErrorMsgsUpdated = createEvent(this, "partyMixErrorMsgsUpdated", 7);
        this.partyMixModel = new PartyMix();
        this.configLoaded = false;
        this.disableCounters = false;
        this.checkMaxPartySize = () => {
            var _a, _b, _c, _d;
            const exceedsMaxPartySize = this.partyMixModel.exceedsMaxPartySize(this.maxPartySize, this.adultCount, this.childCount);
            if (exceedsMaxPartySize) {
                this.addPartyMixErrorMsg((_b = (_a = this.config.qqForm) === null || _a === void 0 ? void 0 : _a.validationErrors) === null || _b === void 0 ? void 0 : _b.maxPartySize);
            }
            else {
                this.removePartyMixErrorMsg((_d = (_c = this.config.qqForm) === null || _c === void 0 ? void 0 : _c.validationErrors) === null || _d === void 0 ? void 0 : _d.maxPartySize);
            }
        };
        this.addPartyMixErrorMsg = (errorMsgToAdd) => {
            this.partyMixErrorMsgs.add(errorMsgToAdd);
            this.partyMixErrorMsgsUpdated.emit(this.partyMixErrorMsgs);
        };
        this.removePartyMixErrorMsg = (errorMsgToRemove) => {
            this.partyMixErrorMsgs.delete(errorMsgToRemove);
            this.partyMixErrorMsgsUpdated.emit(this.partyMixErrorMsgs);
        };
        this.addCountErrorMsg = (e, isAdultCount, newErrMsg) => {
            // Removes error message from RA counter component
            e.target.valid = true;
            // Remove any previously set error message
            const oldErrMsg = isAdultCount ? this.adultCountErrorMsg : this.childCountErrorMsg;
            this.removePartyMixErrorMsg(oldErrMsg);
            if (!newErrMsg) {
                newErrMsg = e.detail.errorMessage;
            }
            this.addPartyMixErrorMsg(newErrMsg);
            if (isAdultCount) {
                this.adultCountErrorMsg = newErrMsg;
            }
            else {
                this.childCountErrorMsg = newErrMsg;
            }
        };
        this.invalidCount = (e, isAdultCount) => {
            var _a;
            let errorMsg = '';
            const validationErrors = (_a = this.config.qqForm) === null || _a === void 0 ? void 0 : _a.validationErrors;
            const maxValue = isAdultCount ? this.maxAdults : this.maxChildren;
            const minValue = isAdultCount ? this.minAdults : this.minChildren;
            if (!e.detail.value) {
                errorMsg = isAdultCount ? validationErrors.emptyNumberOfAdults : validationErrors.emptyNumberOfChildren;
            }
            else {
                const invalidValue = parseInt(e.detail.value);
                if (invalidValue > maxValue) {
                    errorMsg = isAdultCount ? validationErrors.maxNumberOfAdults : validationErrors.maxNumberOfChildren;
                }
                else if (invalidValue < minValue) {
                    errorMsg = isAdultCount ? validationErrors.minNumberOfAdults : validationErrors.minNumberOfChildren;
                }
            }
            this.addCountErrorMsg(e, isAdultCount, errorMsg);
        };
        this.invalidAdultCount = (e) => {
            this.invalidCount(e, true);
        };
        this.invalidChildCount = (e) => {
            this.invalidCount(e, false);
        };
        this.updateAdultCount = (e) => {
            this.adultCount = parseInt(e.target.value);
            this.updateRoomFormDataHandler({ [this.adultCountParamName]: this.adultCount });
            this.removePartyMixErrorMsg(this.adultCountErrorMsg);
            this.checkMaxPartySize();
        };
        this.updateChildCount = async (event) => {
            this.childCount = event.target.value;
            if (this.childCount === 0) {
                // reset warning message hidden in case it has been shown
                this.showChildAgesWarningMessage = false;
            }
            const oldChildCount = this.childrenWithAges.length;
            if (this.childCount !== oldChildCount) {
                const isIncrease = this.childCount > oldChildCount;
                const childCountChange = Math.abs(this.childCount - oldChildCount);
                // if isIncrease, push child count and ALSO set event listener on child count to update that 
                // child's age by ID
                if (isIncrease) {
                    for (let i = 1; i <= childCountChange; i++) {
                        await this.childrenWithAges.push({ id: oldChildCount + i, age: undefined });
                    }
                }
                else {
                    for (let i = 0; i < childCountChange; i++) {
                        this.childErrorsArray = this.childErrorsArray.filter(value => value !== (oldChildCount - i));
                        this.deleteRoomFormDataHandler(`${this.childParamName}${oldChildCount - i}`);
                        this.childrenWithAges.pop();
                    }
                }
            }
            this.updateShowChildAgesDropdown();
            this.updateRoomFormDataHandler({ [this.childCountParamName]: this.childCount });
            this.removePartyMixErrorMsg(this.childCountErrorMsg);
            this.checkMaxPartySize();
        };
        this.handleAgeSelection = (e, id) => {
            const childIndex = parseInt(id);
            const childAgeValue = this.partyMixModel.parseChildAgeValue(e.detail.value);
            this.childrenWithAges[childIndex - 1].age = childAgeValue;
            const roomFormKey = `${this.childParamName}${childIndex}`;
            if (childAgeValue === undefined) {
                this.deleteRoomFormDataHandler(roomFormKey);
            }
            else {
                this.childErrorsArray = this.childErrorsArray.filter(value => value !== id);
                this.updateRoomFormDataHandler({ [roomFormKey]: childAgeValue });
            }
            this.updateShowChildAgesDropdown();
        };
        this.getSelectedAge = (child) => {
            let selectedIndex = 0;
            if (child === null || child === void 0 ? void 0 : child.age) {
                // If age is 1, set to 'Infant' index which should be the last option
                if (parseInt(child.age) === 1 && !parseInt(this.childAgeOptions[this.childAgeOptions.length - 1])) {
                    selectedIndex = this.childAgeOptions.length - 1;
                }
                else {
                    selectedIndex = this.childAgeOptions.findIndex((option => option === child.age.toString()));
                }
            }
            return (selectedIndex + 1).toString();
        };
        this.updateAriaLabelValue = (label, newValue) => {
            if (!label)
                return;
            return label.replace(/\[\d+\]/, newValue.toString());
        };
        this.adultCount = PARTY_MIX_DEFAULTS.adultCount;
        this.childCount = PARTY_MIX_DEFAULTS.childCount;
        this.childrenWithAges = [];
        this.adultCountParamName = 'numberOfAdults';
        this.childCountParamName = 'numberOfChildren';
        this.childParamName = 'kid';
        this.childErrorsArray = [];
        this.config = undefined;
        this.minAdults = 1;
        this.maxAdults = undefined;
        this.minChildren = 0;
        this.maxChildren = undefined;
        this.maxPartySize = undefined;
        this.showChildAgesWarningMessage = false;
        this.updateRoomFormDataHandler = undefined;
        this.deleteRoomFormDataHandler = undefined;
        this.displayChildAges = undefined;
        this.showChildAges = undefined;
        this.partyMixErrorMsgs = new Set('');
        this.adultCountErrorMsg = '';
        this.childCountErrorMsg = '';
    }
    watchForDisplayChildAgesChange() {
        this.updateShowChildAgesDropdown();
    }
    connectedCallback() {
        var _a, _b;
        const childAges = ((_b = (_a = this.config.elements.child) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.multiOptions) || [];
        this.childAgeOptions = childAges;
    }
    componentDidLoad() {
        this.updateShowChildAgesDropdown();
    }
    componentShouldUpdate() {
        this.disableCounters = this.partyMixModel.isMaxPartySize(this.maxPartySize, this.adultCount, this.childCount);
        if (this.childErrorsArray.length) {
            this.showChildAgesWarningMessage = true;
        }
        else {
            this.showChildAgesWarningMessage = false;
        }
    }
    updateShowChildAgesDropdown() {
        const missingChildAges = this.childrenWithAges.filter(obj => obj.age === undefined);
        if (missingChildAges.length > 0) {
            this.showChildAges = true;
            return;
        }
        if (this.childrenWithAges.length > 0 && this.displayChildAges) {
            this.showChildAges = true;
            return;
        }
        this.showChildAges = false;
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        return (h("div", { class: "party-mix-select plus-minus block below" }, h("div", { class: "party-selection party-selection-adult" }, h("label", { htmlFor: "qqForm_adultCount", class: "control-label party-selection-label" }, (_b = (_a = this.config.elements.numberOfAdults) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.label), h("div", { class: "party-selection-option" }, h("wdpr-counter", { id: "qqForm_adultCount", value: this.adultCount, onUpdated: this.updateAdultCount, onInvalidValue: (e) => this.invalidAdultCount(e), "lower-limit": this.minAdults, "upper-limit": this.maxAdults, "increment-label": this.updateAriaLabelValue((_f = (_e = (_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.numberOfAdults) === null || _e === void 0 ? void 0 : _e.options) === null || _f === void 0 ? void 0 : _f.increaseButtonAriaLabel, this.adultCount), "decrement-label": this.updateAriaLabelValue((_k = (_j = (_h = (_g = this.config) === null || _g === void 0 ? void 0 : _g.elements) === null || _h === void 0 ? void 0 : _h.numberOfAdults) === null || _j === void 0 ? void 0 : _j.options) === null || _k === void 0 ? void 0 : _k.decreaseButtonAriaLabel, this.adultCount), "plus-disabled": this.disableCounters }))), h("div", { class: "party-selection party-selection-child" }, h("label", { htmlFor: "qqForm_childCount", class: "control-label party-selection-label" }, (_m = (_l = this.config.elements.numberOfChildren) === null || _l === void 0 ? void 0 : _l.options) === null || _m === void 0 ? void 0 : _m.label), h("div", { class: "party-selection-option" }, h("wdpr-counter", { id: "qqForm_childCount", value: this.childCount, onUpdated: this.updateChildCount, onInvalidValue: (e) => this.invalidChildCount(e), "lower-limit": this.minChildren, "upper-limit": this.maxChildren, "increment-label": this.updateAriaLabelValue((_r = (_q = (_p = (_o = this.config) === null || _o === void 0 ? void 0 : _o.elements) === null || _p === void 0 ? void 0 : _p.numberOfChildren) === null || _q === void 0 ? void 0 : _q.options) === null || _r === void 0 ? void 0 : _r.increaseButtonAriaLabel, this.childCount), "decrement-label": this.updateAriaLabelValue((_v = (_u = (_t = (_s = this.config) === null || _s === void 0 ? void 0 : _s.elements) === null || _t === void 0 ? void 0 : _t.numberOfChildren) === null || _u === void 0 ? void 0 : _u.options) === null || _v === void 0 ? void 0 : _v.decreaseButtonAriaLabel, this.childCount), "plus-disabled": this.disableCounters }))), (this.showChildAges && this.childCount > 0 && !((_x = (_w = this.config.collections.partyMixTickets) === null || _w === void 0 ? void 0 : _w.options) === null || _x === void 0 ? void 0 : _x.suppressChildAges)) &&
            h("div", { class: "party-selection child-age-container" }, h("div", { class: "child-age", id: "childAge", role: "menu" }, h("div", { class: "child-age-label-container" }, ((_z = (_y = this.config.elements.child) === null || _y === void 0 ? void 0 : _y.options) === null || _z === void 0 ? void 0 : _z.childrenAgesLabel) || PARTY_MIX_DEFAULTS.childAgeLabel), h("div", { class: "child-age-selections-container" }, this.childrenWithAges.map(child => {
                var _a, _b;
                return h("div", { class: "party-selection-select", id: "partyMixSelectChildAge" }, h("div", { class: "party-selection-option" }, h("div", { class: "form-group standard", "show-validation-state": true }, h("wdpr-single-select", { id: `kid-${child.id}`, label: lodash.replace((_b = (_a = this.config.elements.child) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.label, '{{number}}', child.id), value: this.getSelectedAge(child), "onItem-selected": (e) => this.handleAgeSelection(e, child.id), ref: (el) => this[`child${child.id}Element`] = el, options: this.childAgeOptions, placeholder: PARTY_MIX_DEFAULTS.childAgePlaceholder, class: `${this.childErrorsArray.includes(child.id) ? 'has-error' : ''}` }))));
            })), this.showChildAgesWarningMessage &&
                h("div", { class: "warning-message-container" }, h("span", { class: "di di20 di-alert alert-icon" }), h("span", { class: "warning-message", innerHTML: (_1 = (_0 = this.config.qqForm) === null || _0 === void 0 ? void 0 : _0.validationErrors) === null || _1 === void 0 ? void 0 : _1.childAges }))))));
    }
    static get watchers() { return {
        "displayChildAges": ["watchForDisplayChildAgesChange"]
    }; }
    static get style() { return wdprPartyMixSelectCss; }
}, [1, "wdpr-party-mix-select", {
        "adultCount": [1026, "adult-count"],
        "childCount": [1026, "child-count"],
        "childrenWithAges": [16],
        "adultCountParamName": [1, "adult-count-param-name"],
        "childCountParamName": [1, "child-count-param-name"],
        "childParamName": [1, "child-param-name"],
        "childErrorsArray": [1040],
        "config": [8],
        "minAdults": [2, "min-adults"],
        "maxAdults": [2, "max-adults"],
        "minChildren": [2, "min-children"],
        "maxChildren": [2, "max-children"],
        "maxPartySize": [2, "max-party-size"],
        "updateRoomFormDataHandler": [16],
        "deleteRoomFormDataHandler": [16],
        "displayChildAges": [4, "display-child-ages"],
        "showChildAgesWarningMessage": [32],
        "showChildAges": [32],
        "partyMixErrorMsgs": [32],
        "adultCountErrorMsg": [32],
        "childCountErrorMsg": [32]
    }, undefined, {
        "displayChildAges": ["watchForDisplayChildAgesChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wdpr-party-mix-select"];
    components.forEach(tagName => { switch (tagName) {
        case "wdpr-party-mix-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WdprPartyMixSelect);
            }
            break;
    } });
}

export { ANALYTICS_LINK_IDS as A, DROPDOWN_FIELDS as D, WdprPartyMixSelect as W, DEFAULT_PARAM_NAMES as a, DATE_RANGE_DEFAULTS as b, createCommonjsModule as c, defineCustomElement as d, lodash as l };

